/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export * from './_completedEvaluationLinks';
export * from './_pendingEvaluationLinks';
export * from './abortOralExamHeaders';
export * from './acknowledgeOralExamConductHeaders';
export * from './addCourseModuleRequest';
export * from './addCourseModuleRequestSegmentId';
export * from './addCoursestudentBody';
export * from './addModuleToCourseBody';
export * from './addModuleToCourseParams';
export * from './addUserToCourseRequest';
export * from './addUserToCourseRequestAccessibleModuleIds';
export * from './addUserToCourseRequestExtraModuleIds';
export * from './adminOverride';
export * from './adminSetPasswordRequest';
export * from './advanceOralExamQuestionBody';
export * from './advanceOralExamQuestionHeaders';
export * from './aiTutorEvaluationResponse';
export * from './aiTutorEvaluationResponseDimension';
export * from './aiTutorEvaluationResponseDimensionLevel';
export * from './aiTutorEvaluationResponseEvaluation';
export * from './aiTutorEvaluationResponseFormativeFeedback';
export * from './aiTutorFormativeFeedback';
export * from './aiTutorFormativeFeedbackFocusQualityAssessment';
export * from './aiTutorFormativeFeedbackRoutingDecision';
export * from './aiTutorMessage';
export * from './aiTutorMessageRole';
export * from './answerKeyPoint';
export * from './apiError';
export * from './apiErrorDetails';
export * from './apiErrorDetailsAnyOf';
export * from './appSchemasApiResourcesMediaType';
export * from './appSchemasDbResourcesMediaType';
export * from './appointmentSession';
export * from './appointmentSlot';
export * from './appointmentSlotBoundTaskId';
export * from './appointmentSlotCancelledAt';
export * from './appointmentSlotCancelledBy';
export * from './appointmentSlotInviteResponseAt';
export * from './appointmentSlotInviteResponseStatus';
export * from './appointmentSlotLivekitRoomName';
export * from './appointmentSlotMeetingCreatedAt';
export * from './appointmentSlotRecurrence';
export * from './appointmentSlotStatus';
export * from './appointmentSlotVideoMeetingCalendarEventId';
export * from './appointmentSlotVideoMeetingId';
export * from './appointmentSlotVideoMeetingJoinUrl';
export * from './appointmentSlotVideoMeetingModeratorUrl';
export * from './appointmentSlotVideoMeetingPassword';
export * from './appointmentSlotVideoMeetingProvider';
export * from './approvalDecision';
export * from './approvalDecisionComment';
export * from './approvalRequest';
export * from './approvalRequestApprovalType';
export * from './approvalRequestChangelog';
export * from './approvalRequestComment';
export * from './approvalRequestHeadline';
export * from './approvalRequestImpactNotice';
export * from './approvalRequestOfferToVersions';
export * from './approvalRequestVersionsToReplace';
export * from './approveModuleVersionBody';
export * from './approveOralExamIdVerificationHeaders';
export * from './assessmentDifficulty';
export * from './assessmentMode';
export * from './assessmentRequest';
export * from './assessmentRequestAdditionalInstructions';
export * from './assessmentRequestFocusTasks';
export * from './assessmentRequestSubmissionId';
export * from './assessmentResponse';
export * from './attachment';
export * from './attachmentDeleteResponse';
export * from './attachmentDeleteResponseEtag';
export * from './attachmentFilesize';
export * from './attachmentPolicy';
export * from './attachmentThumbnailUrl';
export * from './attachmentUploadResponse';
export * from './attachmentUploadResponseEtag';
export * from './attachmentUrl';
export * from './autogradeJobParams';
export * from './autogradeOnSubmissionRequest';
export * from './autogradeOralExamParams';
export * from './autograderStudentFeedback';
export * from './autograderStudentFeedbackInput';
export * from './autograderStudentFeedbackOutput';
export * from './availableNotificationsResponse';
export * from './availableNotificationsResponseDefaultsByRole';
export * from './availableNotificationsResponseDisabled';
export * from './availableNotificationsResponseEffectiveEnabled';
export * from './availableNotificationsResponseOverrides';
export * from './availableNotificationsResponsePreferences';
export * from './baseModel';
export * from './batchTaskSubmissionTrainingDataRequest';
export * from './batchTrainingDataRequest';
export * from './batchTrainingDataRequestDatasetName';
export * from './binaryPassFailProjector';
export * from './bodyAddResourceForTaskTasksTaskIdResourcesPost';
export * from './bodyAddResourceForTaskTasksTaskIdResourcesPostFile';
export * from './bodyAddResourceForTaskTasksTaskIdResourcesPostLinkUrl';
export * from './bodyCreateTaskResource';
export * from './bodyCreateTaskResourceCitation';
export * from './bodyCreateTaskResourceDescription';
export * from './bodyCreateTaskResourceFile';
export * from './bodyCreateTaskResourceLink';
export * from './bodyCreateTaskResourceLinkCitation';
export * from './bodyCreateTaskResourceLinkDescription';
export * from './bodyCreateTaskResourceLinkTitle';
export * from './bodyCreateTaskResourceLinkUrl';
export * from './bodyCreateTaskResourceTitle';
export * from './bodyGenerateTaskRubric';
export * from './bodyGenerateTaskRubricDraftTask';
export * from './bodyGenerateTaskRubricTaskAnalysis';
export * from './bodyPrepareTaskResourceFileUpload';
export * from './bodyPrepareTaskResourceFileUploadCitation';
export * from './bodyPrepareTaskResourceFileUploadDescription';
export * from './bodyPrepareTaskResourceFileUploadTitle';
export * from './bodyUploadAttachment';
export * from './bodyUploadMcqOptionImage';
export * from './bodyUploadMcqQuestionImage';
export * from './bodyUploadModuleImage';
export * from './bodyUploadModuleVersionImage';
export * from './bodyUploadOptionImageModulesModuleIdVersionsVersionTasksTaskIdMcqQuestionsQuestionIdOptionsOptionIdImagePost';
export * from './bodyUploadQuestionImageModulesModuleIdVersionsVersionTasksTaskIdMcqQuestionsQuestionIdImagePost';
export * from './booking';
export * from './bookingAttendedMinutes';
export * from './bookingCancellationReason';
export * from './bookingCancelledAt';
export * from './bookingCompletedAt';
export * from './bookingInviteResponseAt';
export * from './bookingInviteResponseStatus';
export * from './bookingMeetingEndedAt';
export * from './bookingMeetingStartedAt';
export * from './bookingOralExamJoinState';
export * from './bookingRecordingUrl';
export * from './bookingReminderSentAt';
export * from './bookingStatus';
export * from './bookingStudentEmail';
export * from './bookingStudentName';
export * from './bookingVideoMeetingCalendarEventId';
export * from './bookingVideoMeetingJoinUrl';
export * from './bookingVideoMeetingModeratorUrl';
export * from './bookingVideoMeetingProvider';
export * from './boundTaskRef';
export * from './boundTaskRefModuleTitle';
export * from './boundTaskRefTaskTitle';
export * from './broadcastOralExamCohortMessageHeaders';
export * from './bulkJobParameters';
export * from './bulkJobParametersEntityIdsItem';
export * from './bulkJobParametersOptions';
export * from './bulkReassignSubmissionsParams';
export * from './businessStudentCommentOutput';
export * from './cancelOralExamBookingAllowRebookingHeaders';
export * from './cancelOralExamTechnicalHeaders';
export * from './categoryGradeResult';
export * from './categoryGradeResultGrade';
export * from './chatHistory';
export * from './chatRequest';
export * from './cliLoginRequest';
export * from './cliLoginResponse';
export * from './closeOralExamCohortBody';
export * from './closeOralExamCohortHeaders';
export * from './closeOralExamWrapUpHeaders';
export * from './cohort';
export * from './cohortInput';
export * from './cohortInsights';
export * from './cohortOutput';
export * from './cohortState';
export * from './cohortStateChangedAt';
export * from './cohortStateProperty';
export * from './cohortSummary';
export * from './cohortUpdateRequest';
export * from './cohortUpdateRequestIsDeprecated';
export * from './cohortUpdateRequestState';
export * from './completeOralExamIfAbsentHeaders';
export * from './completedEvaluation';
export * from './completedEvaluationGrade';
export * from './completedEvaluationGrading';
export * from './conceptCluster';
export * from './conceptClusterDescription';
export * from './conceptEdge';
export * from './conceptEdgeDescription';
export * from './conceptGraphInput';
export * from './conceptGraphOutput';
export * from './conceptNode';
export * from './conceptNodeClusterId';
export * from './conceptNodeDescription';
export * from './conceptRelationType';
export * from './connectionOccasion';
export * from './connectionOccasionType';
export * from './connectionPeer';
export * from './connectionPeerEmail';
export * from './connectionPeerFirstName';
export * from './connectionPeerPhone';
export * from './connectionPeerProfilePhotoBlobPath';
export * from './connectionPeerProfilePhotoUrl';
export * from './connectionPeerWhatsapp';
export * from './connectionRequestBody';
export * from './connectionStatus';
export * from './connectionView';
export * from './connectionViewDirection';
export * from './contentStudioConfig';
export * from './contentStudioConfigStudyProgram';
export * from './contentStudioMaterializeRequest';
export * from './contentStudioMaterializeRequestConfig';
export * from './contentStudioMaterializeRequestOriginalPrompt';
export * from './contentStudioQuestion';
export * from './contentStudioQuestionHelpText';
export * from './contentStudioQuestionOptions';
export * from './contentStudioStage1Request';
export * from './contentStudioStage1RequestConfig';
export * from './contentStudioStage1RequestResources';
export * from './contentStudioStage1Response';
export * from './contentStudioStage2Request';
export * from './contentStudioStage2RequestConfig';
export * from './contentStudioStage2Response';
export * from './contentStudioStage3Request';
export * from './contentStudioStage3RequestConfig';
export * from './contentStudioStage3Response';
export * from './course';
export * from './courseExternalProductId';
export * from './courseLifecycleState';
export * from './courseModule';
export * from './courseModuleAuthor';
export * from './courseModuleCorrector';
export * from './courseModuleCourseSettings';
export * from './courseModuleCourses';
export * from './courseModuleExamAttempt';
export * from './courseModuleGrading';
export * from './courseModuleGradingConfigSnapshot';
export * from './courseModuleImageUrl';
export * from './courseModuleIsDeprecated';
export * from './courseModuleMandates';
export * from './courseModuleMetadata';
export * from './courseModuleResponsibilities';
export * from './courseModuleSettings';
export * from './courseModuleSettingsAllowPartialSubmission';
export * from './courseModuleSettingsCorrector';
export * from './courseModuleSettingsEcts';
export * from './courseModuleSettingsExamTaskIds';
export * from './courseModuleSettingsInput';
export * from './courseModuleSettingsInputAllowPartialSubmission';
export * from './courseModuleSettingsInputChapterId';
export * from './courseModuleSettingsInputCorrector';
export * from './courseModuleSettingsInputEcts';
export * from './courseModuleSettingsInputEnabledEventKinds';
export * from './courseModuleSettingsInputExamTaskIds';
export * from './courseModuleSettingsInputLearningHours';
export * from './courseModuleSettingsInputMandates';
export * from './courseModuleSettingsInputModuleId';
export * from './courseModuleSettingsInputResponsibilities';
export * from './courseModuleSettingsInputSegmentId';
export * from './courseModuleSettingsInputSortIndex';
export * from './courseModuleSettingsLearningHours';
export * from './courseModuleSettingsModuleId';
export * from './courseModuleSettingsOutput';
export * from './courseModuleSettingsOutputAllowPartialSubmission';
export * from './courseModuleSettingsOutputChapterId';
export * from './courseModuleSettingsOutputCorrector';
export * from './courseModuleSettingsOutputEcts';
export * from './courseModuleSettingsOutputEnabledEventKinds';
export * from './courseModuleSettingsOutputExamTaskIds';
export * from './courseModuleSettingsOutputLearningHours';
export * from './courseModuleSettingsOutputMandates';
export * from './courseModuleSettingsOutputModuleId';
export * from './courseModuleSettingsOutputResponsibilities';
export * from './courseModuleSettingsOutputSegmentId';
export * from './courseModuleSettingsOutputSortIndex';
export * from './courseModuleSettingsSortIndex';
export * from './courseModuleSummary';
export * from './courseModuleSummaryAllowPartialSubmission';
export * from './courseModuleSummaryAuthorName';
export * from './courseModuleSummaryChapterId';
export * from './courseModuleSummaryCorrector';
export * from './courseModuleSummaryEcts';
export * from './courseModuleSummaryEnabledEventKinds';
export * from './courseModuleSummaryExamTaskIds';
export * from './courseModuleSummaryLearningHours';
export * from './courseModuleSummaryMandates';
export * from './courseModuleSummaryModuleId';
export * from './courseModuleSummarySegmentId';
export * from './courseModuleSummarySortIndex';
export * from './courseModuleSummaryState';
export * from './courseModuleSummaryTitle';
export * from './courseModuleSummaryVersion';
export * from './courseModuleUpdateRequest';
export * from './courseModuleUpgradeOffer';
export * from './courseObligation';
export * from './courseObligationScope';
export * from './courseReference';
export * from './courseReferenceState';
export * from './courseSegment';
export * from './courseSegmentId';
export * from './courseSegments';
export * from './courseState';
export * from './courseStateChangedAt';
export * from './courseStateProperty';
export * from './courseStudent';
export * from './courseStudentAccessibleModuleIds';
export * from './courseStudentAvatar';
export * from './courseStudentCohort';
export * from './courseStudentContext';
export * from './courseStudentExternalStudentId';
export * from './courseStudentFeatures';
export * from './courseStudentOrderId';
export * from './courseStudentPassword';
export * from './courseStudentProfilePhotoBlobPath';
export * from './courseStudentState';
export * from './courseStudentTitle';
export * from './courseStudentTrial';
export * from './courseStudentUpdateRequest';
export * from './courseStudentUpdateRequestAccessibleModuleIds';
export * from './courseStudentUpdateRequestEnrollmentDate';
export * from './courseStudentUpdateRequestExtraModuleIds';
export * from './courseStudentUpdateRequestOrderId';
export * from './courseStudentUpdateRequestState';
export * from './courseUpdateRequest';
export * from './courseUpdateRequestExternalProductId';
export * from './courseUpdateRequestIsDeprecated';
export * from './courseUpdateRequestSegments';
export * from './courseUpdateRequestState';
export * from './coverageAnalysis';
export * from './coverageAnalysisAvailableCount';
export * from './coverageAnalysisFilledSegments';
export * from './coverageAnalysisFirstSegmentFilled';
export * from './coverageAnalysisHorizonDays';
export * from './coverageAnalysisMinOptions';
export * from './coverageAnalysisRequiredSegments';
export * from './coverageAnalysisSegments';
export * from './coverageAnalysisSeverity';
export * from './coverageSegment';
export * from './createBookingRequest';
export * from './createCourseRequest';
export * from './createCourseRequestExternalProductId';
export * from './createCourseRequestSegments';
export * from './createModuleVersionBody';
export * from './createModuleVersionParams';
export * from './createSlotsRequest';
export * from './createSlotsRequestBindings';
export * from './createSlotsRequestBoundTaskId';
export * from './createSlotsRequestCapacity';
export * from './createSlotsRequestDurationMinutes';
export * from './createSlotsRequestRecurrence';
export * from './createTaskModulesModuleIdTasksPostParams';
export * from './createTaskSubmissionParams';
export * from './deleteTaskParams';
export * from './dimObjectives';
export * from './documentProgress';
export * from './documentProgressInput';
export * from './documentProgressOutput';
export * from './emailNotificationPreferences';
export * from './emailNotificationPreferencesPreferences';
export * from './endOralExamHeaders';
export * from './evalDimRating';
export * from './evalDimRatingComment';
export * from './evalDimRatingCriteriaEvaluations';
export * from './evalDimRatingLevel';
export * from './evaluationDimension';
export * from './evaluationDimensionComment';
export * from './evaluationDimensionInput';
export * from './evaluationDimensionInputComment';
export * from './evaluationDimensionInputLevel';
export * from './evaluationDimensionLevel';
export * from './evaluationDimensionMaxWeight';
export * from './evaluationDimensionOutput';
export * from './evaluationFeedbackCategory';
export * from './evaluationMonitoringParams';
export * from './eventCoverageCheckParams';
export * from './eventKind';
export * from './eventKindAllowedTimeEnd';
export * from './eventKindAllowedTimeStart';
export * from './eventKindConductedBy';
export * from './eventKindCoverage';
export * from './eventKindCoverageFreq';
export * from './eventKindCoverageMinAvailableSlotsRolling';
export * from './eventKindCoverageMinOptionsPerStudent';
export * from './eventKindKind';
export * from './eventKindLecturerRoleLabel';
export * from './eventKindMaxCapacityOverride';
export * from './eventKindMaxDurationMin';
export * from './eventKindMinCapacity';
export * from './eventKindMinCapacityOverride';
export * from './eventKindMinDurationMin';
export * from './eventKindOralExamDefaults';
export * from './eventKindPlanning';
export * from './eventKindPlanningFreq';
export * from './eventKindPlanningMinAvailableSlotsRolling';
export * from './eventKindRequiredFeatureFlag';
export * from './eventKindRequiresEvaluation';
export * from './eventKindRequiresRecording';
export * from './eventKindSendLecturerReminderHoursBefore';
export * from './eventKindSendParticipantReminderHoursBefore';
export * from './eventKindStartAuthority';
export * from './eventKindVideoProvider';
export * from './eventParticipantReminderParams';
export * from './eventPlanningCheckParams';
export * from './eventTaskConfig';
export * from './eventTaskConfigCapacityOverride';
export * from './eventTaskConfigDurationMinutesOverride';
export * from './eventTaskConfigLocked';
export * from './eventTaskConfigRecordingConsentText';
export * from './eventTaskConfigUnlockConditions';
export * from './eventUnlockConditions';
export * from './eventUnlockConditionsType';
export * from './examAdmission';
export * from './examAdmissionAdmittedAt';
export * from './examAdmissionAdmittedBy';
export * from './examAttemptReportResponse';
export * from './examAttemptReportResponseGradingConfigSnapshot';
export * from './examAttemptStatus';
export * from './examAttemptStatusAllowed';
export * from './examAttemptStatusLatestFailureReason';
export * from './examAttemptStatusSupportEmail';
export * from './examAttemptStatusUsed';
export * from './examQuestion';
export * from './examQuestionTaskRef';
export * from './examSessionResponse';
export * from './examSessionResponseAdmitted';
export * from './examSessionResponseAutoCloseAt';
export * from './examSessionResponseBookingStatus';
export * from './examSessionResponseClosedAt';
export * from './examSessionResponseClosedBy';
export * from './examSessionResponseOpenedAt';
export * from './examSessionResponseOpenedBy';
export * from './examSessionResponseTimeLimitMinutes';
export * from './examSessionResponseTimeRemainingSeconds';
export * from './exportedLevel';
export * from './exportedModule';
export * from './exportedModuleInput';
export * from './exportedModuleInputSourceModuleId';
export * from './exportedModuleInputWorkload';
export * from './exportedModuleOutput';
export * from './exportedModuleOutputSourceModuleId';
export * from './exportedModuleOutputWorkload';
export * from './exportedModuleSourceModuleId';
export * from './exportedModuleWorkload';
export * from './exportedResource';
export * from './exportedResourceInput';
export * from './exportedResourceInputDigest';
export * from './exportedResourceInputResourceId';
export * from './exportedResourceInputResourceRef';
export * from './exportedResourceInputUrl';
export * from './exportedResourceOutput';
export * from './exportedResourceOutputDigest';
export * from './exportedResourceOutputResourceId';
export * from './exportedResourceOutputResourceRef';
export * from './exportedResourceOutputUrl';
export * from './exportedResourceResourceId';
export * from './exportedResourceUrl';
export * from './exportedTask';
export * from './exportedTaskDescription';
export * from './exportedTaskInput';
export * from './exportedTaskInputDescription';
export * from './exportedTaskInputEvaluation';
export * from './exportedTaskInputEvaluationAnyOf';
export * from './exportedTaskInputLevel';
export * from './exportedTaskInputObjectives';
export * from './exportedTaskInputObjectivesAnyOf';
export * from './exportedTaskInputRubric';
export * from './exportedTaskInputRubricAnyOf';
export * from './exportedTaskInputTaskRef';
export * from './exportedTaskLevel';
export * from './exportedTaskObjectives';
export * from './exportedTaskObjectivesAnyOf';
export * from './exportedTaskOutput';
export * from './exportedTaskOutputDescription';
export * from './exportedTaskOutputEvaluation';
export * from './exportedTaskOutputEvaluationAnyOf';
export * from './exportedTaskOutputLevel';
export * from './exportedTaskOutputObjectives';
export * from './exportedTaskOutputObjectivesAnyOf';
export * from './exportedTaskOutputRubric';
export * from './exportedTaskOutputRubricAnyOf';
export * from './exportedTaskOutputTaskRef';
export * from './extras';
export * from './extrasAt';
export * from './extrasN';
export * from './extrasNStudents';
export * from './extrasP20';
export * from './extrasP80';
export * from './extrasParts';
export * from './extrasPartsAnyOf';
export * from './extrasTooFew';
export * from './extrasWeekly';
export * from './fileUploadUrlResponse';
export * from './flatTaskEvaluationInput';
export * from './flatTaskEvaluationInputDimensions';
export * from './flatTaskEvaluationOutput';
export * from './flatTaskEvaluationOutputDimensions';
export * from './generateOralExamPoolParams';
export * from './generateTaskAnalysisBody';
export * from './generateTaskAnalysisParams';
export * from './generateTaskAnalysisStreamBody';
export * from './generateTaskDescriptionParams';
export * from './generateTaskDescriptionStreamBody';
export * from './generateTaskObjectivesBody';
export * from './generateTaskObjectivesParams';
export * from './generateTaskObjectivesStreamBody';
export * from './generateTaskRubricBody';
export * from './generateTaskRubricParams';
export * from './generateTaskRubricStreamBody';
export * from './genericApiResponse';
export * from './genericApiResponseAiTutorEvaluationResponse';
export * from './genericApiResponseAiTutorEvaluationResponseData';
export * from './genericApiResponseAiTutorEvaluationResponseError';
export * from './genericApiResponseAiTutorEvaluationResponseMessage';
export * from './genericApiResponseAiTutorEvaluationResponsePagination';
export * from './genericApiResponseAiTutorFormativeFeedback';
export * from './genericApiResponseAiTutorFormativeFeedbackData';
export * from './genericApiResponseAiTutorFormativeFeedbackError';
export * from './genericApiResponseAiTutorFormativeFeedbackMessage';
export * from './genericApiResponseAiTutorFormativeFeedbackPagination';
export * from './genericApiResponseAppointmentSlot';
export * from './genericApiResponseAppointmentSlotData';
export * from './genericApiResponseAppointmentSlotError';
export * from './genericApiResponseAppointmentSlotMessage';
export * from './genericApiResponseAppointmentSlotPagination';
export * from './genericApiResponseAssessmentResponse';
export * from './genericApiResponseAssessmentResponseData';
export * from './genericApiResponseAssessmentResponseError';
export * from './genericApiResponseAssessmentResponseMessage';
export * from './genericApiResponseAssessmentResponsePagination';
export * from './genericApiResponseAttachment';
export * from './genericApiResponseAttachmentData';
export * from './genericApiResponseAttachmentDeleteResponse';
export * from './genericApiResponseAttachmentDeleteResponseData';
export * from './genericApiResponseAttachmentDeleteResponseError';
export * from './genericApiResponseAttachmentDeleteResponseMessage';
export * from './genericApiResponseAttachmentDeleteResponsePagination';
export * from './genericApiResponseAttachmentError';
export * from './genericApiResponseAttachmentMessage';
export * from './genericApiResponseAttachmentPagination';
export * from './genericApiResponseAttachmentUploadResponse';
export * from './genericApiResponseAttachmentUploadResponseData';
export * from './genericApiResponseAttachmentUploadResponseError';
export * from './genericApiResponseAttachmentUploadResponseMessage';
export * from './genericApiResponseAttachmentUploadResponsePagination';
export * from './genericApiResponseAvailableNotificationsResponse';
export * from './genericApiResponseAvailableNotificationsResponseData';
export * from './genericApiResponseAvailableNotificationsResponseError';
export * from './genericApiResponseAvailableNotificationsResponseMessage';
export * from './genericApiResponseAvailableNotificationsResponsePagination';
export * from './genericApiResponseBooking';
export * from './genericApiResponseBookingData';
export * from './genericApiResponseBookingError';
export * from './genericApiResponseBookingMessage';
export * from './genericApiResponseBookingPagination';
export * from './genericApiResponseBool';
export * from './genericApiResponseBoolData';
export * from './genericApiResponseBoolError';
export * from './genericApiResponseBoolMessage';
export * from './genericApiResponseBoolPagination';
export * from './genericApiResponseChatHistory';
export * from './genericApiResponseChatHistoryData';
export * from './genericApiResponseChatHistoryError';
export * from './genericApiResponseChatHistoryMessage';
export * from './genericApiResponseChatHistoryPagination';
export * from './genericApiResponseCliLoginResponse';
export * from './genericApiResponseCliLoginResponseData';
export * from './genericApiResponseCliLoginResponseError';
export * from './genericApiResponseCliLoginResponseMessage';
export * from './genericApiResponseCliLoginResponsePagination';
export * from './genericApiResponseCohort';
export * from './genericApiResponseCohortData';
export * from './genericApiResponseCohortError';
export * from './genericApiResponseCohortMessage';
export * from './genericApiResponseCohortPagination';
export * from './genericApiResponseConnectionView';
export * from './genericApiResponseConnectionViewData';
export * from './genericApiResponseConnectionViewError';
export * from './genericApiResponseConnectionViewMessage';
export * from './genericApiResponseConnectionViewPagination';
export * from './genericApiResponseCourse';
export * from './genericApiResponseCourseData';
export * from './genericApiResponseCourseError';
export * from './genericApiResponseCourseMessage';
export * from './genericApiResponseCourseModuleSettings';
export * from './genericApiResponseCourseModuleSettingsData';
export * from './genericApiResponseCourseModuleSettingsError';
export * from './genericApiResponseCourseModuleSettingsMessage';
export * from './genericApiResponseCourseModuleSettingsPagination';
export * from './genericApiResponseCourseModuleSummary';
export * from './genericApiResponseCourseModuleSummaryData';
export * from './genericApiResponseCourseModuleSummaryError';
export * from './genericApiResponseCourseModuleSummaryMessage';
export * from './genericApiResponseCourseModuleSummaryPagination';
export * from './genericApiResponseCoursePagination';
export * from './genericApiResponseCourseStudent';
export * from './genericApiResponseCourseStudentData';
export * from './genericApiResponseCourseStudentError';
export * from './genericApiResponseCourseStudentMessage';
export * from './genericApiResponseCourseStudentPagination';
export * from './genericApiResponseData';
export * from './genericApiResponseDict';
export * from './genericApiResponseDictData';
export * from './genericApiResponseDictDataAnyOf';
export * from './genericApiResponseDictError';
export * from './genericApiResponseDictMessage';
export * from './genericApiResponseDictPagination';
export * from './genericApiResponseDictStrBool';
export * from './genericApiResponseDictStrBoolData';
export * from './genericApiResponseDictStrBoolDataAnyOf';
export * from './genericApiResponseDictStrBoolError';
export * from './genericApiResponseDictStrBoolMessage';
export * from './genericApiResponseDictStrBoolPagination';
export * from './genericApiResponseDictStrStr';
export * from './genericApiResponseDictStrStrData';
export * from './genericApiResponseDictStrStrDataAnyOf';
export * from './genericApiResponseDictStrStrError';
export * from './genericApiResponseDictStrStrMessage';
export * from './genericApiResponseDictStrStrPagination';
export * from './genericApiResponseDictStrUnionStrNoneType';
export * from './genericApiResponseDictStrUnionStrNoneTypeData';
export * from './genericApiResponseDictStrUnionStrNoneTypeDataAnyOf';
export * from './genericApiResponseDictStrUnionStrNoneTypeError';
export * from './genericApiResponseDictStrUnionStrNoneTypeMessage';
export * from './genericApiResponseDictStrUnionStrNoneTypePagination';
export * from './genericApiResponseError';
export * from './genericApiResponseExamAttemptReportResponse';
export * from './genericApiResponseExamAttemptReportResponseData';
export * from './genericApiResponseExamAttemptReportResponseError';
export * from './genericApiResponseExamAttemptReportResponseMessage';
export * from './genericApiResponseExamAttemptReportResponsePagination';
export * from './genericApiResponseExamSessionResponse';
export * from './genericApiResponseExamSessionResponseData';
export * from './genericApiResponseExamSessionResponseError';
export * from './genericApiResponseExamSessionResponseMessage';
export * from './genericApiResponseExamSessionResponsePagination';
export * from './genericApiResponseExportedModule';
export * from './genericApiResponseExportedModuleData';
export * from './genericApiResponseExportedModuleError';
export * from './genericApiResponseExportedModuleMessage';
export * from './genericApiResponseExportedModulePagination';
export * from './genericApiResponseFileUploadUrlResponse';
export * from './genericApiResponseFileUploadUrlResponseData';
export * from './genericApiResponseFileUploadUrlResponseError';
export * from './genericApiResponseFileUploadUrlResponseMessage';
export * from './genericApiResponseFileUploadUrlResponsePagination';
export * from './genericApiResponseGrading';
export * from './genericApiResponseGradingData';
export * from './genericApiResponseGradingError';
export * from './genericApiResponseGradingMessage';
export * from './genericApiResponseGradingPagination';
export * from './genericApiResponseGradingStatsReport';
export * from './genericApiResponseGradingStatsReportData';
export * from './genericApiResponseGradingStatsReportError';
export * from './genericApiResponseGradingStatsReportMessage';
export * from './genericApiResponseGradingStatsReportPagination';
export * from './genericApiResponseGssOccasionPeopleResponse';
export * from './genericApiResponseGssOccasionPeopleResponseData';
export * from './genericApiResponseGssOccasionPeopleResponseError';
export * from './genericApiResponseGssOccasionPeopleResponseMessage';
export * from './genericApiResponseGssOccasionPeopleResponsePagination';
export * from './genericApiResponseIdPhotoUrlResponse';
export * from './genericApiResponseIdPhotoUrlResponseData';
export * from './genericApiResponseIdPhotoUrlResponseError';
export * from './genericApiResponseIdPhotoUrlResponseMessage';
export * from './genericApiResponseIdPhotoUrlResponsePagination';
export * from './genericApiResponseListAppointmentSlot';
export * from './genericApiResponseListAppointmentSlotData';
export * from './genericApiResponseListAppointmentSlotError';
export * from './genericApiResponseListAppointmentSlotMessage';
export * from './genericApiResponseListAppointmentSlotPagination';
export * from './genericApiResponseListAttachment';
export * from './genericApiResponseListAttachmentData';
export * from './genericApiResponseListAttachmentError';
export * from './genericApiResponseListAttachmentMessage';
export * from './genericApiResponseListAttachmentPagination';
export * from './genericApiResponseListBooking';
export * from './genericApiResponseListBookingData';
export * from './genericApiResponseListBookingError';
export * from './genericApiResponseListBookingMessage';
export * from './genericApiResponseListBookingPagination';
export * from './genericApiResponseListCompletedEvaluation';
export * from './genericApiResponseListCompletedEvaluationData';
export * from './genericApiResponseListCompletedEvaluationError';
export * from './genericApiResponseListCompletedEvaluationMessage';
export * from './genericApiResponseListCompletedEvaluationPagination';
export * from './genericApiResponseListConnectionView';
export * from './genericApiResponseListConnectionViewData';
export * from './genericApiResponseListConnectionViewError';
export * from './genericApiResponseListConnectionViewMessage';
export * from './genericApiResponseListConnectionViewPagination';
export * from './genericApiResponseListCourse';
export * from './genericApiResponseListCourseData';
export * from './genericApiResponseListCourseError';
export * from './genericApiResponseListCourseMessage';
export * from './genericApiResponseListCourseModule';
export * from './genericApiResponseListCourseModuleData';
export * from './genericApiResponseListCourseModuleError';
export * from './genericApiResponseListCourseModuleMessage';
export * from './genericApiResponseListCourseModulePagination';
export * from './genericApiResponseListCoursePagination';
export * from './genericApiResponseListCourseStudent';
export * from './genericApiResponseListCourseStudentData';
export * from './genericApiResponseListCourseStudentError';
export * from './genericApiResponseListCourseStudentMessage';
export * from './genericApiResponseListCourseStudentPagination';
export * from './genericApiResponseListMandate';
export * from './genericApiResponseListMandateData';
export * from './genericApiResponseListMandateError';
export * from './genericApiResponseListMandateMessage';
export * from './genericApiResponseListMandatePagination';
export * from './genericApiResponseListModule';
export * from './genericApiResponseListModuleData';
export * from './genericApiResponseListModuleError';
export * from './genericApiResponseListModuleLecturerResponse';
export * from './genericApiResponseListModuleLecturerResponseData';
export * from './genericApiResponseListModuleLecturerResponseError';
export * from './genericApiResponseListModuleLecturerResponseMessage';
export * from './genericApiResponseListModuleLecturerResponsePagination';
export * from './genericApiResponseListModuleMessage';
export * from './genericApiResponseListModulePagination';
export * from './genericApiResponseListModuleRequest';
export * from './genericApiResponseListModuleRequestData';
export * from './genericApiResponseListModuleRequestError';
export * from './genericApiResponseListModuleRequestMessage';
export * from './genericApiResponseListModuleRequestPagination';
export * from './genericApiResponseListPendingEvaluation';
export * from './genericApiResponseListPendingEvaluationData';
export * from './genericApiResponseListPendingEvaluationError';
export * from './genericApiResponseListPendingEvaluationMessage';
export * from './genericApiResponseListPendingEvaluationPagination';
export * from './genericApiResponseListResource';
export * from './genericApiResponseListResourceData';
export * from './genericApiResponseListResourceMessage';
export * from './genericApiResponseListResourceMetadata';
export * from './genericApiResponseListResourceMetadataData';
export * from './genericApiResponseListResourceMetadataMessage';
export * from './genericApiResponseListResourceMetadataPagination';
export * from './genericApiResponseListResourcePagination';
export * from './genericApiResponseListScheduledChangeSummary';
export * from './genericApiResponseListScheduledChangeSummaryData';
export * from './genericApiResponseListScheduledChangeSummaryError';
export * from './genericApiResponseListScheduledChangeSummaryMessage';
export * from './genericApiResponseListScheduledChangeSummaryPagination';
export * from './genericApiResponseListSchedulingObligation';
export * from './genericApiResponseListSchedulingObligationData';
export * from './genericApiResponseListSchedulingObligationError';
export * from './genericApiResponseListSchedulingObligationMessage';
export * from './genericApiResponseListSchedulingObligationPagination';
export * from './genericApiResponseListTask';
export * from './genericApiResponseListTaskData';
export * from './genericApiResponseListTaskError';
export * from './genericApiResponseListTaskMessage';
export * from './genericApiResponseListTaskPagination';
export * from './genericApiResponseListTaskSubmissionVersionSummary';
export * from './genericApiResponseListTaskSubmissionVersionSummaryData';
export * from './genericApiResponseListTaskSubmissionVersionSummaryError';
export * from './genericApiResponseListTaskSubmissionVersionSummaryMessage';
export * from './genericApiResponseListTaskSubmissionVersionSummaryPagination';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponse';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponseData';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponseDataAnyOfItem';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponseError';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponseMessage';
export * from './genericApiResponseListUnionCourseModuleModuleLecturerResponsePagination';
export * from './genericApiResponseListUser';
export * from './genericApiResponseListUserActivity';
export * from './genericApiResponseListUserActivityData';
export * from './genericApiResponseListUserActivityError';
export * from './genericApiResponseListUserActivityMessage';
export * from './genericApiResponseListUserActivityPagination';
export * from './genericApiResponseListUserData';
export * from './genericApiResponseListUserError';
export * from './genericApiResponseListUserMessage';
export * from './genericApiResponseListUserPagination';
export * from './genericApiResponseListUserResourceProgress';
export * from './genericApiResponseListUserResourceProgressData';
export * from './genericApiResponseListUserResourceProgressError';
export * from './genericApiResponseListUserResourceProgressMessage';
export * from './genericApiResponseListUserResourceProgressPagination';
export * from './genericApiResponseLoginResponse';
export * from './genericApiResponseLoginResponseData';
export * from './genericApiResponseLoginResponseError';
export * from './genericApiResponseLoginResponseMessage';
export * from './genericApiResponseLoginResponsePagination';
export * from './genericApiResponseMaintenanceEventApi';
export * from './genericApiResponseMaintenanceEventApiData';
export * from './genericApiResponseMaintenanceEventApiError';
export * from './genericApiResponseMaintenanceEventApiMessage';
export * from './genericApiResponseMaintenanceEventApiPagination';
export * from './genericApiResponseMessage';
export * from './genericApiResponseMetricsResponse';
export * from './genericApiResponseMetricsResponseData';
export * from './genericApiResponseMetricsResponseError';
export * from './genericApiResponseMetricsResponseMessage';
export * from './genericApiResponseMetricsResponsePagination';
export * from './genericApiResponseModule';
export * from './genericApiResponseModuleData';
export * from './genericApiResponseModuleError';
export * from './genericApiResponseModuleGradeResult';
export * from './genericApiResponseModuleGradeResultData';
export * from './genericApiResponseModuleGradeResultError';
export * from './genericApiResponseModuleGradeResultMessage';
export * from './genericApiResponseModuleGradeResultPagination';
export * from './genericApiResponseModuleLecturerResponse';
export * from './genericApiResponseModuleLecturerResponseData';
export * from './genericApiResponseModuleLecturerResponseError';
export * from './genericApiResponseModuleLecturerResponseMessage';
export * from './genericApiResponseModuleLecturerResponsePagination';
export * from './genericApiResponseModuleMessage';
export * from './genericApiResponseModulePagination';
export * from './genericApiResponseModuleSubmissionResponse';
export * from './genericApiResponseModuleSubmissionResponseData';
export * from './genericApiResponseModuleSubmissionResponseError';
export * from './genericApiResponseModuleSubmissionResponseMessage';
export * from './genericApiResponseModuleSubmissionResponsePagination';
export * from './genericApiResponseModuleUpgradeAcceptResponse';
export * from './genericApiResponseModuleUpgradeAcceptResponseData';
export * from './genericApiResponseModuleUpgradeAcceptResponseError';
export * from './genericApiResponseModuleUpgradeAcceptResponseMessage';
export * from './genericApiResponseModuleUpgradeAcceptResponsePagination';
export * from './genericApiResponseModuleUpgradePreviewResponse';
export * from './genericApiResponseModuleUpgradePreviewResponseData';
export * from './genericApiResponseModuleUpgradePreviewResponseError';
export * from './genericApiResponseModuleUpgradePreviewResponseMessage';
export * from './genericApiResponseModuleUpgradePreviewResponsePagination';
export * from './genericApiResponseMoveResult';
export * from './genericApiResponseMoveResultData';
export * from './genericApiResponseMoveResultError';
export * from './genericApiResponseMoveResultMessage';
export * from './genericApiResponseMoveResultPagination';
export * from './genericApiResponseNoneType';
export * from './genericApiResponseNoneTypeError';
export * from './genericApiResponseNoneTypeMessage';
export * from './genericApiResponseNoneTypePagination';
export * from './genericApiResponseOralExamAgentControlStateResponse';
export * from './genericApiResponseOralExamAgentControlStateResponseData';
export * from './genericApiResponseOralExamAgentControlStateResponseError';
export * from './genericApiResponseOralExamAgentControlStateResponseMessage';
export * from './genericApiResponseOralExamAgentControlStateResponsePagination';
export * from './genericApiResponseOralExamAggregateCohortStateResponse';
export * from './genericApiResponseOralExamAggregateCohortStateResponseData';
export * from './genericApiResponseOralExamAggregateCohortStateResponseError';
export * from './genericApiResponseOralExamAggregateCohortStateResponseMessage';
export * from './genericApiResponseOralExamAggregateCohortStateResponsePagination';
export * from './genericApiResponseOralExamAggregateTimeSlotStateResponse';
export * from './genericApiResponseOralExamAggregateTimeSlotStateResponseData';
export * from './genericApiResponseOralExamAggregateTimeSlotStateResponseError';
export * from './genericApiResponseOralExamAggregateTimeSlotStateResponseMessage';
export * from './genericApiResponseOralExamAggregateTimeSlotStateResponsePagination';
export * from './genericApiResponseOralExamCohortStateResponse';
export * from './genericApiResponseOralExamCohortStateResponseData';
export * from './genericApiResponseOralExamCohortStateResponseError';
export * from './genericApiResponseOralExamCohortStateResponseMessage';
export * from './genericApiResponseOralExamCohortStateResponsePagination';
export * from './genericApiResponseOralExamConfig';
export * from './genericApiResponseOralExamConfigData';
export * from './genericApiResponseOralExamConfigError';
export * from './genericApiResponseOralExamConfigMessage';
export * from './genericApiResponseOralExamConfigPagination';
export * from './genericApiResponseOralExamEvaluationResult';
export * from './genericApiResponseOralExamEvaluationResultData';
export * from './genericApiResponseOralExamEvaluationResultError';
export * from './genericApiResponseOralExamEvaluationResultMessage';
export * from './genericApiResponseOralExamEvaluationResultPagination';
export * from './genericApiResponseOralExamHandshakeCanaryResponse';
export * from './genericApiResponseOralExamHandshakeCanaryResponseData';
export * from './genericApiResponseOralExamHandshakeCanaryResponseError';
export * from './genericApiResponseOralExamHandshakeCanaryResponseMessage';
export * from './genericApiResponseOralExamHandshakeCanaryResponsePagination';
export * from './genericApiResponseOralExamLoungeResponse';
export * from './genericApiResponseOralExamLoungeResponseData';
export * from './genericApiResponseOralExamLoungeResponseError';
export * from './genericApiResponseOralExamLoungeResponseMessage';
export * from './genericApiResponseOralExamLoungeResponsePagination';
export * from './genericApiResponseOralExamPracticeAvailabilityResponse';
export * from './genericApiResponseOralExamPracticeAvailabilityResponseData';
export * from './genericApiResponseOralExamPracticeAvailabilityResponseError';
export * from './genericApiResponseOralExamPracticeAvailabilityResponseMessage';
export * from './genericApiResponseOralExamPracticeAvailabilityResponsePagination';
export * from './genericApiResponseOralExamPracticeEnsureResponse';
export * from './genericApiResponseOralExamPracticeEnsureResponseData';
export * from './genericApiResponseOralExamPracticeEnsureResponseError';
export * from './genericApiResponseOralExamPracticeEnsureResponseMessage';
export * from './genericApiResponseOralExamPracticeEnsureResponsePagination';
export * from './genericApiResponseOralExamRunStateResponse';
export * from './genericApiResponseOralExamRunStateResponseData';
export * from './genericApiResponseOralExamRunStateResponseError';
export * from './genericApiResponseOralExamRunStateResponseMessage';
export * from './genericApiResponseOralExamRunStateResponsePagination';
export * from './genericApiResponseOralExamTimeSlotStateResponse';
export * from './genericApiResponseOralExamTimeSlotStateResponseData';
export * from './genericApiResponseOralExamTimeSlotStateResponseError';
export * from './genericApiResponseOralExamTimeSlotStateResponseMessage';
export * from './genericApiResponseOralExamTimeSlotStateResponsePagination';
export * from './genericApiResponseOralExamTokenResponse';
export * from './genericApiResponseOralExamTokenResponseData';
export * from './genericApiResponseOralExamTokenResponseError';
export * from './genericApiResponseOralExamTokenResponseMessage';
export * from './genericApiResponseOralExamTokenResponsePagination';
export * from './genericApiResponsePagination';
export * from './genericApiResponsePeopleProfile';
export * from './genericApiResponsePeopleProfileData';
export * from './genericApiResponsePeopleProfileError';
export * from './genericApiResponsePeopleProfileMessage';
export * from './genericApiResponsePeopleProfilePagination';
export * from './genericApiResponsePeopleProfilePhotoUrlResponse';
export * from './genericApiResponsePeopleProfilePhotoUrlResponseData';
export * from './genericApiResponsePeopleProfilePhotoUrlResponseError';
export * from './genericApiResponsePeopleProfilePhotoUrlResponseMessage';
export * from './genericApiResponsePeopleProfilePhotoUrlResponsePagination';
export * from './genericApiResponseResource';
export * from './genericApiResponseResourceData';
export * from './genericApiResponseResourceError';
export * from './genericApiResponseResourceMessage';
export * from './genericApiResponseResourceMetadata';
export * from './genericApiResponseResourceMetadataData';
export * from './genericApiResponseResourceMetadataMessage';
export * from './genericApiResponseResourceMetadataPagination';
export * from './genericApiResponseResourcePagination';
export * from './genericApiResponseRubricPromptData';
export * from './genericApiResponseRubricPromptDataData';
export * from './genericApiResponseRubricPromptDataError';
export * from './genericApiResponseRubricPromptDataMessage';
export * from './genericApiResponseRubricPromptDataPagination';
export * from './genericApiResponseScheduledChangeDetail';
export * from './genericApiResponseScheduledChangeDetailData';
export * from './genericApiResponseScheduledChangeDetailError';
export * from './genericApiResponseScheduledChangeDetailMessage';
export * from './genericApiResponseScheduledChangeDetailPagination';
export * from './genericApiResponseStr';
export * from './genericApiResponseStrData';
export * from './genericApiResponseStrError';
export * from './genericApiResponseStrMessage';
export * from './genericApiResponseStrPagination';
export * from './genericApiResponseStudentEngagementRosterInfo';
export * from './genericApiResponseStudentEngagementRosterInfoData';
export * from './genericApiResponseStudentEngagementRosterInfoError';
export * from './genericApiResponseStudentEngagementRosterInfoMessage';
export * from './genericApiResponseStudentEngagementRosterInfoPagination';
export * from './genericApiResponseStudentProgressReport';
export * from './genericApiResponseStudentProgressReportData';
export * from './genericApiResponseStudentProgressReportError';
export * from './genericApiResponseStudentProgressReportMessage';
export * from './genericApiResponseStudentProgressReportPagination';
export * from './genericApiResponseSubmission';
export * from './genericApiResponseSubmissionData';
export * from './genericApiResponseSubmissionError';
export * from './genericApiResponseSubmissionMessage';
export * from './genericApiResponseSubmissionPagination';
export * from './genericApiResponseSubmissionReport';
export * from './genericApiResponseSubmissionReportData';
export * from './genericApiResponseSubmissionReportError';
export * from './genericApiResponseSubmissionReportMessage';
export * from './genericApiResponseSubmissionReportPagination';
export * from './genericApiResponseSupervisorPhotoUrlResponse';
export * from './genericApiResponseSupervisorPhotoUrlResponseData';
export * from './genericApiResponseSupervisorPhotoUrlResponseError';
export * from './genericApiResponseSupervisorPhotoUrlResponseMessage';
export * from './genericApiResponseSupervisorPhotoUrlResponsePagination';
export * from './genericApiResponseTask';
export * from './genericApiResponseTaskData';
export * from './genericApiResponseTaskError';
export * from './genericApiResponseTaskMessage';
export * from './genericApiResponseTaskPagination';
export * from './genericApiResponseTaskSubmissionVersionDetail';
export * from './genericApiResponseTaskSubmissionVersionDetailData';
export * from './genericApiResponseTaskSubmissionVersionDetailError';
export * from './genericApiResponseTaskSubmissionVersionDetailMessage';
export * from './genericApiResponseTaskSubmissionVersionDetailPagination';
export * from './genericApiResponseTenantPublicSettings';
export * from './genericApiResponseTenantPublicSettingsData';
export * from './genericApiResponseTenantPublicSettingsError';
export * from './genericApiResponseTenantPublicSettingsMessage';
export * from './genericApiResponseTenantPublicSettingsPagination';
export * from './genericApiResponseThumbsDownCheck';
export * from './genericApiResponseThumbsDownCheckData';
export * from './genericApiResponseThumbsDownCheckError';
export * from './genericApiResponseThumbsDownCheckMessage';
export * from './genericApiResponseThumbsDownCheckPagination';
export * from './genericApiResponseThumbsDownList';
export * from './genericApiResponseThumbsDownListData';
export * from './genericApiResponseThumbsDownListError';
export * from './genericApiResponseThumbsDownListMessage';
export * from './genericApiResponseThumbsDownListPagination';
export * from './genericApiResponseTokenResponse';
export * from './genericApiResponseTokenResponseData';
export * from './genericApiResponseTokenResponseError';
export * from './genericApiResponseTokenResponseMessage';
export * from './genericApiResponseTokenResponsePagination';
export * from './genericApiResponseTrainingDataExport';
export * from './genericApiResponseTrainingDataExportData';
export * from './genericApiResponseTrainingDataExportError';
export * from './genericApiResponseTrainingDataExportMessage';
export * from './genericApiResponseTrainingDataExportPagination';
export * from './genericApiResponseUnionGradingNoneType';
export * from './genericApiResponseUnionGradingNoneTypeData';
export * from './genericApiResponseUnionGradingNoneTypeError';
export * from './genericApiResponseUnionGradingNoneTypeMessage';
export * from './genericApiResponseUnionGradingNoneTypePagination';
export * from './genericApiResponseUnionModuleModuleLecturerResponse';
export * from './genericApiResponseUnionModuleModuleLecturerResponseData';
export * from './genericApiResponseUnionModuleModuleLecturerResponseError';
export * from './genericApiResponseUnionModuleModuleLecturerResponseMessage';
export * from './genericApiResponseUnionModuleModuleLecturerResponsePagination';
export * from './genericApiResponseUser';
export * from './genericApiResponseUserData';
export * from './genericApiResponseUserError';
export * from './genericApiResponseUserMessage';
export * from './genericApiResponseUserPagination';
export * from './genericApiResponseUserResourceProgress';
export * from './genericApiResponseUserResourceProgressData';
export * from './genericApiResponseUserResourceProgressError';
export * from './genericApiResponseUserResourceProgressMessage';
export * from './genericApiResponseUserResourceProgressPagination';
export * from './genericApiResponseWorkingModeApplyResponse';
export * from './genericApiResponseWorkingModeApplyResponseData';
export * from './genericApiResponseWorkingModeApplyResponseError';
export * from './genericApiResponseWorkingModeApplyResponseMessage';
export * from './genericApiResponseWorkingModeApplyResponsePagination';
export * from './genericApiResponseWorkingModeDiff';
export * from './genericApiResponseWorkingModeDiffData';
export * from './genericApiResponseWorkingModeDiffError';
export * from './genericApiResponseWorkingModeDiffMessage';
export * from './genericApiResponseWorkingModeDiffPagination';
export * from './germanBandedProjector';
export * from './germanLegacyEssayProjector';
export * from './germanLegacyOralProjector';
export * from './getAiTutorThumbsDownGated';
export * from './getAiTutorThumbsDownParams';
export * from './getAllCohortsCohortsGetParams';
export * from './getAllCoursesParams';
export * from './getAllCoursestudentsParams';
export * from './getAllJobsParams';
export * from './getAllUsersParams';
export * from './getAutogradeEvaluationParams';
export * from './getAutogradeFeedbackParams';
export * from './getEnrollmentsReportReportsEnrollmentsGetParams';
export * from './getEvalHistoryForLecturerUsersMeEvaluationsHistoryGetParams';
export * from './getEvaluationsForLecturerParams';
export * from './getEventTasksForLecturerParams';
export * from './getGradingStatsReportParams';
export * from './getJobStatusJobsGetParams';
export * from './getJobStatusParams';
export * from './getLecturerSlotsParams';
export * from './getLecturerSubmissionByUserTaskParams';
export * from './getMcqQuestionsCoursesCourseIdModulesModuleIdTasksTaskIdMcqQuestionsGetParams';
export * from './getMcqStudentQuestionsParams';
export * from './getMetricsGated';
export * from './getMetricsParams';
export * from './getModuleByCourseAndIdParams';
export * from './getModuleParams';
export * from './getModuleUpgradeOfferPreviewParams';
export * from './getModuleVersionParams';
export * from './getModuleWorkingModeDiffParams';
export * from './getModuleWorkingModeDiffTarget';
export * from './getModulesByCourseParams';
export * from './getModulesParams';
export * from './getOralExamAgentControlStateParams';
export * from './getOralExamIdPhotoUrlKind';
export * from './getOralExamIdPhotoUrlParams';
export * from './getOralExamPracticeParams';
export * from './getOralExamSessionAgentControlStateParams';
export * from './getResourceAccessResourcesResourceIdLinkGetParams';
export * from './getResourceByIdParams';
export * from './getResourceHistoricMetadataParams';
export * from './getResourceThumbnailParams';
export * from './getResourcesResourcesGetParams';
export * from './getStudentProgressReportParams';
export * from './getStudentSubmissionByUserTaskParams';
export * from './getSubmissionsReportParams';
export * from './getSupervisorPhotoUrlParams';
export * from './getTaskByCourseModuleParams';
export * from './getTaskByModuleTaskIdParams';
export * from './getTaskByModuleVersionParams';
export * from './getTaskParams';
export * from './getTasksByCourseModuleParams';
export * from './getTasksByModuleParams';
export * from './getTasksByModuleVersionParams';
export * from './getTasksByUserCourseModuleParams';
export * from './getUserBookingsParams';
export * from './gradePreviewRequest';
export * from './gradePreviewRequestModuleSubmissionId';
export * from './gradedAttemptTab';
export * from './gradedAttemptTabMode';
export * from './gradedAttemptTaskFeedback';
export * from './grading';
export * from './gradingAdminOverride';
export * from './gradingComment';
export * from './gradingConfigSnapshotResponse';
export * from './gradingConfigSnapshotResponseDefaultFormalParams';
export * from './gradingConfigSnapshotResponseDefaultFormalParamsAnyOf';
export * from './gradingConfigSnapshotResponseEvalDimensions';
export * from './gradingConfigSnapshotResponseGradeProjector';
export * from './gradingConfigSnapshotResponseGradeProjectorAnyOf';
export * from './gradingConfigSnapshotResponseTaskGradeProjectors';
export * from './gradingConfigSnapshotResponseTaskGradeProjectorsAnyOf';
export * from './gradingDimensionDescription';
export * from './gradingGrade';
export * from './gradingGradedAt';
export * from './gradingScores';
export * from './gradingScoresAnyOf';
export * from './gradingStatsReport';
export * from './gradingStatsReportPagination';
export * from './gradingStatsRow';
export * from './grantExamAttemptRequest';
export * from './gssOccasionPeopleResponse';
export * from './gssOccasionPersonTeaser';
export * from './gssOccasionPersonTeaserConnectionDirection';
export * from './gssOccasionPersonTeaserConnectionId';
export * from './gssOccasionPersonTeaserConnectionStatus';
export * from './gssOccasionPersonTeaserProfilePhotoUrl';
export * from './gssSlotOccasion';
export * from './hTTPValidationError';
export * from './highlightSegment';
export * from './highlightingOutput';
export * from './hubSpotEnrollRequest';
export * from './hubSpotEnrollRequestEnrollments';
export * from './hubSpotEnrollRequestExternalProductIds';
export * from './hubSpotEnrollRequestExternalStudentId';
export * from './hubSpotEnrollRequestFirstname';
export * from './hubSpotEnrollRequestHubspotContactId';
export * from './hubSpotEnrollRequestLastname';
export * from './hubSpotEnrollmentRequest';
export * from './hubSpotEnrollmentRequestHubspotContactId';
export * from './hubSpotEnrollmentRow';
export * from './hubSpotLifecycleRequest';
export * from './hubSpotLifecycleRequestFirstname';
export * from './hubSpotLifecycleRequestHubspotContactId';
export * from './hubSpotLifecycleRequestLastname';
export * from './hubspotEnrollStudentHeaders';
export * from './idPhotoUrlResponse';
export * from './idPhotoUrlResponseUrl';
export * from './idReference';
export * from './idReferenceId';
export * from './idReferenceInput';
export * from './idReferenceInputId';
export * from './idReferenceOutput';
export * from './idTitleReference';
export * from './idTitleReferenceId';
export * from './idTitleReferenceTitle';
export * from './inviteResponseStatus';
export * from './item';
export * from './itemValue';
export * from './jobTypes';
export * from './lecturer';
export * from './lecturerAvatar';
export * from './lecturerBriefingJobParams';
export * from './lecturerBriefingJobParamsLeadTimeHours';
export * from './lecturerBriefingJobParamsSlotId';
export * from './lecturerEvaluationUpdateRequest';
export * from './lecturerEvaluationUpdateRequestEvaluation';
export * from './lecturerEvaluationUpdateRequestEvaluationAnyOf';
export * from './lecturerEvaluationUpdateRequestFeedback';
export * from './lecturerId';
export * from './lecturerInput';
export * from './lecturerInputAvatar';
export * from './lecturerInputId';
export * from './lecturerOutput';
export * from './lecturerPreviewFormativeFeedbackRequest';
export * from './lecturerSessionReminderParams';
export * from './legacyRemark';
export * from './legacyRemarkInput';
export * from './legacyRemarkOutput';
export * from './legacyScoresOutput';
export * from './levelDraft';
export * from './levelEngagement';
export * from './listFigure';
export * from './listFigureUnit';
export * from './listTaskSubmissionHistoryParams';
export * from './llmCriteriaEvaluation';
export * from './loginRequest';
export * from './loginResponse';
export * from './loginResponseToken';
export * from './mCQAnswerUpdateRequest';
export * from './mCQAnswerUpdateResponse';
export * from './mCQAttemptRequest';
export * from './mCQAttemptRequestAnswers';
export * from './mCQAttemptResponse';
export * from './mCQAttemptResponseCorrectAnswers';
export * from './mCQAttemptResponseFeedback';
export * from './mCQConfigInput';
export * from './mCQConfigInputQuestionsToShow';
export * from './mCQConfigInputTimeLimitMinutes';
export * from './mCQConfigOutput';
export * from './mCQConfigOutputQuestionsToShow';
export * from './mCQConfigOutputTimeLimitMinutes';
export * from './mCQGenerationRequest';
export * from './mCQOption';
export * from './mCQOptionCreate';
export * from './mCQOptionCreateFeedback';
export * from './mCQOptionCreateImageAlt';
export * from './mCQOptionCreateImageUrl';
export * from './mCQOptionFeedback';
export * from './mCQOptionImageAlt';
export * from './mCQOptionImageUrl';
export * from './mCQOptionUpdate';
export * from './mCQOptionUpdateFeedback';
export * from './mCQOptionUpdateId';
export * from './mCQOptionUpdateImageAlt';
export * from './mCQOptionUpdateImageUrl';
export * from './mCQQuestion';
export * from './mCQQuestionCreate';
export * from './mCQQuestionCreateDifficulty';
export * from './mCQQuestionCreateExplanation';
export * from './mCQQuestionCreateImageAlt';
export * from './mCQQuestionCreateImageUrl';
export * from './mCQQuestionDifficulty';
export * from './mCQQuestionExplanation';
export * from './mCQQuestionImageAlt';
export * from './mCQQuestionImageUrl';
export * from './mCQQuestionUpdate';
export * from './mCQQuestionUpdateDifficulty';
export * from './mCQQuestionUpdateExplanation';
export * from './mCQQuestionUpdateImageAlt';
export * from './mCQQuestionUpdateImageUrl';
export * from './mCQResultSummary';
export * from './mCQResultSummaryMaxScore';
export * from './mCQResultSummaryPassed';
export * from './mCQResultSummaryScore';
export * from './mCQStudentOption';
export * from './mCQStudentOptionImageAlt';
export * from './mCQStudentOptionImageUrl';
export * from './mCQStudentQuestion';
export * from './mCQStudentQuestionDifficulty';
export * from './mCQStudentQuestionImageAlt';
export * from './mCQStudentQuestionImageUrl';
export * from './mCQStudentQuestionSelectedOptionId';
export * from './maintenanceEventApi';
export * from './maintenanceEventApiInput';
export * from './maintenanceEventApiOutput';
export * from './maintenanceState';
export * from './maintenanceStateCurrentMaintenance';
export * from './mandate';
export * from './mandateAssignment';
export * from './mandateAssignmentEvaluation';
export * from './mandateAssignmentEvents';
export * from './mandateEventKindId';
export * from './mandateEventKindLabel';
export * from './mandateMissingCount';
export * from './mandatePlanningReason';
export * from './mandatePlanningSegment';
export * from './mandatePlanningStatus';
export * from './mandateSegments';
export * from './markOralExamOrientationCompletedHeaders';
export * from './markOralExamPreflightLobbyReadyHeaders';
export * from './markOralExamStudentReadyHeaders';
export * from './mediaTypeInput';
export * from './mediaTypeOutput';
export * from './meetingNotificationsCleanupParams';
export * from './meetingNotificationsEnsureParams';
export * from './meetingsEmptySlotsCancelParams';
export * from './meetingsEventCompletionFinalizeParams';
export * from './meetingsLivekitOralUnwindParams';
export * from './meetingsNoShowFinalizeParams';
export * from './meetingsTeamsOralUnwindParams';
export * from './metadataType';
export * from './metricsContext';
export * from './metricsFilters';
export * from './metricsFiltersGated';
export * from './metricsResponse';
export * from './metricsResponseFiguresItem';
export * from './module';
export * from './moduleAuthor';
export * from './moduleBinding';
export * from './moduleBindingApi';
export * from './moduleBindingApiModuleVersion';
export * from './moduleBindingModuleVersion';
export * from './moduleBindingRequest';
export * from './moduleBindingRequestModuleVersion';
export * from './moduleContext';
export * from './moduleContextCourseId';
export * from './moduleContextCurrentTaskId';
export * from './moduleContextInput';
export * from './moduleContextInputCourseId';
export * from './moduleContextInputCurrentTaskId';
export * from './moduleContextOutput';
export * from './moduleCorrector';
export * from './moduleCourses';
export * from './moduleCreateRequest';
export * from './moduleCreateRequestCorrectorId';
export * from './moduleCreateRequestMandates';
export * from './moduleCreateRequestMetadata';
export * from './moduleCreateRequestResponsibilities';
export * from './moduleCreateRequestState';
export * from './moduleDraft';
export * from './moduleDraftInput';
export * from './moduleDraftOutput';
export * from './moduleEvaluationRequest';
export * from './moduleEvaluationRequestGrading';
export * from './moduleEvaluationRequestTaskEvaluations';
export * from './moduleEvaluationRequestTaskEvaluationsAnyOf';
export * from './moduleExamAttempt';
export * from './moduleGlobalUpdateRequest';
export * from './moduleGlobalUpdateRequestAuthor';
export * from './moduleGlobalUpdateRequestIsDeprecated';
export * from './moduleGlobalUpdateRequestMandates';
export * from './moduleGlobalUpdateRequestResponsibilities';
export * from './moduleGlobalUpdateRequestTitle';
export * from './moduleGradeOverrideRequest';
export * from './moduleGradeOverrideRequestLastKnownEtag';
export * from './moduleGradeResult';
export * from './moduleGradeResultGrade';
export * from './moduleGrading';
export * from './moduleGradingConfigSnapshot';
export * from './moduleImageUrl';
export * from './moduleImportRequest';
export * from './moduleImportRequestReplaceModuleId';
export * from './moduleIsDeprecated';
export * from './moduleLecturerResponse';
export * from './moduleLecturerResponseAuthor';
export * from './moduleLecturerResponseCorrector';
export * from './moduleLecturerResponseCourses';
export * from './moduleLecturerResponseExamAttempt';
export * from './moduleLecturerResponseGrading';
export * from './moduleLecturerResponseGradingConfigSnapshot';
export * from './moduleLecturerResponseImageUrl';
export * from './moduleLecturerResponseIsDeprecated';
export * from './moduleLecturerResponseMandates';
export * from './moduleLecturerResponseMetadata';
export * from './moduleLecturerResponseResponsibilities';
export * from './moduleLecturerResponseUpgradeOffer';
export * from './moduleLecturerResponseVersionHistory';
export * from './moduleLevel';
export * from './moduleLevelInput';
export * from './moduleLevelInputObjectives';
export * from './moduleLevelInputTitle';
export * from './moduleLevelObjectives';
export * from './moduleLevelOutput';
export * from './moduleLevelTitle';
export * from './moduleMandates';
export * from './moduleMetadata';
export * from './moduleMetadataAutogradeOnSubmission';
export * from './moduleMetadataEcts';
export * from './moduleMetadataExaminationBasis';
export * from './moduleMetadataInput';
export * from './moduleMetadataInputEcts';
export * from './moduleMetadataInputLanguage';
export * from './moduleMetadataInputLearningHours';
export * from './moduleMetadataInputLevels';
export * from './moduleMetadataInputObjectives';
export * from './moduleMetadataLanguage';
export * from './moduleMetadataLearningHours';
export * from './moduleMetadataLevels';
export * from './moduleMetadataObjectives';
export * from './moduleMetadataOutput';
export * from './moduleMetadataProperty';
export * from './moduleMetadataTaskCompletionMinLevels';
export * from './moduleMetadataTaskCompletionMinLevelsAnyOf';
export * from './moduleMetadataTaskCompletionPolicy';
export * from './moduleMetadataWorkingMode';
export * from './moduleRequest';
export * from './moduleResponse';
export * from './moduleResponsibilities';
export * from './moduleState';
export * from './moduleStateActiveForCurrentUser';
export * from './moduleStateEditAccessRequested';
export * from './moduleStateGradingDeadlineDays';
export * from './moduleStateGradingDue';
export * from './moduleStateInput';
export * from './moduleStateInputActiveForCurrentUser';
export * from './moduleStateInputEditAccessRequested';
export * from './moduleStateInputStudentWorkflowState';
export * from './moduleStateOutput';
export * from './moduleStateStudentWorkflowState';
export * from './moduleStateTransition';
export * from './moduleStateTransitionComment';
export * from './moduleStateTransitionFromState';
export * from './moduleStateTransitionMetadata';
export * from './moduleStateTransitionMetadataAnyOf';
export * from './moduleSubmissionResponse';
export * from './moduleSubmissionResponseGradedAt';
export * from './moduleSubmissionResponseGrading';
export * from './moduleSubmissionResponseGradingConfigSnapshot';
export * from './moduleSubmissionResponseModuleVersion';
export * from './moduleSubmissionResponseSubmittedAt';
export * from './moduleSubmissionState';
export * from './moduleSubmissionUpdateRequest';
export * from './moduleSubmissionUpdateRequestGrading';
export * from './moduleSubmissionUpdateRequestTaskSubmissions';
export * from './moduleSubmissionUpdateRequestTaskSubmissionsAnyOf';
export * from './moduleUpdateRequest';
export * from './moduleUpdateRequestAuthor';
export * from './moduleUpdateRequestCorrector';
export * from './moduleUpdateRequestIsDeprecated';
export * from './moduleUpdateRequestMandates';
export * from './moduleUpdateRequestMetadata';
export * from './moduleUpdateRequestResponsibilities';
export * from './moduleUpdateRequestState';
export * from './moduleUpdateRequestTitle';
export * from './moduleUpgradeAcceptRequest';
export * from './moduleUpgradeAcceptResponse';
export * from './moduleUpgradeChangeSummary';
export * from './moduleUpgradeChangeSummaryAddedByType';
export * from './moduleUpgradeChangeSummaryAiTutorGainedByType';
export * from './moduleUpgradeChangeSummaryGradeBasisAfterByType';
export * from './moduleUpgradeChangeSummaryGradeBasisBeforeByType';
export * from './moduleUpgradeChangeSummaryRemovedByType';
export * from './moduleUpgradeOffer';
export * from './moduleUpgradeOfferChangeSummary';
export * from './moduleUpgradeOfferProperty';
export * from './moduleUpgradePreviewGroup';
export * from './moduleUpgradePreviewGroupChangeSummary';
export * from './moduleUpgradePreviewResponse';
export * from './moduleUpgradeTaskChange';
export * from './moduleVersionApprovalType';
export * from './moduleVersionCreateRequest';
export * from './moduleVersionCreateRequestSourceVersion';
export * from './moduleVersionState';
export * from './moduleWorkflowState';
export * from './moveResult';
export * from './moveStudentsRequest';
export * from './moveStudentsRequestAccessibleModuleIds';
export * from './moveStudentsRequestSourceCourseIds';
export * from './notificationKindInfo';
export * from './numberFigure';
export * from './numberFigureUnit';
export * from './numberFigureValue';
export * from './openExamRequest';
export * from './openExamRequestTimeLimitMinutes';
export * from './openExamSessionBody';
export * from './openMcqExamBody';
export * from './openOralExamAnswerWindowHeaders';
export * from './openOralExamGroupBriefingHeaders';
export * from './oralExamAcknowledgeConductRequest';
export * from './oralExamAdvanceRequest';
export * from './oralExamAdvanceRequestQuestionId';
export * from './oralExamAdvanceTrigger';
export * from './oralExamAgentControlStateResponse';
export * from './oralExamAgentControlStateResponseAnswerStartedAt';
export * from './oralExamAgentControlStateResponseConductPhase';
export * from './oralExamAgentControlStateResponseCurrentQuestionId';
export * from './oralExamAgentControlStateResponseEndReason';
export * from './oralExamAgentControlStateResponseEventsWritableReason';
export * from './oralExamAgentControlStateResponseExaminerReadyAt';
export * from './oralExamAgentControlStateResponseOperationalFault';
export * from './oralExamAgentControlStateResponsePauseReason';
export * from './oralExamAgentControlStateResponsePresentedAt';
export * from './oralExamAgentControlStateResponseQuestionDeadline';
export * from './oralExamAgentControlStateResponseQuestionIndex';
export * from './oralExamAgentControlStateResponseQuestionTotal';
export * from './oralExamAgentControlStateResponseRunState';
export * from './oralExamAgentControlStateResponseStageGate';
export * from './oralExamAgentControlStateResponseStudentDoneAt';
export * from './oralExamAgentControlStateResponseStudentReadyAt';
export * from './oralExamAgentFailoverRequest';
export * from './oralExamAgentFailoverRequestCause';
export * from './oralExamAgentFailoverRequestDispatchGeneration';
export * from './oralExamAgentFailoverRequestReason';
export * from './oralExamAggregateCohortStateResponse';
export * from './oralExamAggregateCohortStateResponseActiveDropInBookingId';
export * from './oralExamAggregateCohortStateResponseEtag';
export * from './oralExamAggregateCohortStateResponseInExamEnteredAt';
export * from './oralExamAggregateCohortStateResponseStageGate';
export * from './oralExamAggregateCohortStateResponseSupervisorBroadcast';
export * from './oralExamAggregateTimeSlotStateResponse';
export * from './oralExamAggregateTimeSlotStateResponseActiveDropInBookingId';
export * from './oralExamAggregateTimeSlotStateResponseBrieferId';
export * from './oralExamAggregateTimeSlotStateResponseEtag';
export * from './oralExamAggregateTimeSlotStateResponseInExamEnteredAt';
export * from './oralExamAggregateTimeSlotStateResponseSlotOwnerId';
export * from './oralExamAggregateTimeSlotStateResponseStageGate';
export * from './oralExamAggregateTimeSlotStateResponseSupervisionAbsence';
export * from './oralExamAggregateTimeSlotStateResponseSupervisorBroadcast';
export * from './oralExamAggregateTimeSlotStateResponseSupervisorCheckedInAt';
export * from './oralExamAggregateTimeSlotStateResponseSupervisorNoShowAt';
export * from './oralExamAggregateTimeSlotStateResponseTechnicalCancelledAt';
export * from './oralExamBookingRunSummary';
export * from './oralExamBookingRunSummaryIdPhotoBlobPath';
export * from './oralExamBookingRunSummaryIdSelfiePhotoBlobPath';
export * from './oralExamBookingRunSummaryStudentName';
export * from './oralExamBroadcastMessageRequest';
export * from './oralExamCloseTimeSlotRequest';
export * from './oralExamCloseTimeSlotRequestInProgressOutcome';
export * from './oralExamCohortStateResponse';
export * from './oralExamCohortStateResponseEtag';
export * from './oralExamCohortStateResponseInExamEnteredAt';
export * from './oralExamCohortStateResponseStageGate';
export * from './oralExamConductPhase';
export * from './oralExamConfig';
export * from './oralExamConfigGeneratedAt';
export * from './oralExamConfigGenerationPromptVersion';
export * from './oralExamConfigLastEditedAt';
export * from './oralExamConfigQuestionCount';
export * from './oralExamConfigQuestionPoolLock';
export * from './oralExamConfigRegisteredExamAt';
export * from './oralExamConfigResolvedQuestionCount';
export * from './oralExamConfigResolvedSecondsPerQuestion';
export * from './oralExamConfigSecondsPerQuestion';
export * from './oralExamConfigUpdate';
export * from './oralExamConfigUpdateQuestionCount';
export * from './oralExamConfigUpdateSecondsPerQuestion';
export * from './oralExamConsentRecord';
export * from './oralExamCurrentQuestion';
export * from './oralExamCurrentQuestionAnswerKey';
export * from './oralExamDriver';
export * from './oralExamDropInHeaders';
export * from './oralExamDropInRequest';
export * from './oralExamDropInRequestBookingId';
export * from './oralExamDropInRequestRung';
export * from './oralExamEgressGuardReconcileParams';
export * from './oralExamEvaluationResult';
export * from './oralExamEvaluationResultGrade';
export * from './oralExamEventKindDefaults';
export * from './oralExamHandshakeCanaryResponse';
export * from './oralExamHandshakeCanaryResponseClassifiedAt';
export * from './oralExamHandshakeCanaryResponseVerdict';
export * from './oralExamIdRejectionReason';
export * from './oralExamIdVerificationState';
export * from './oralExamIdVerificationStateRejectionReason';
export * from './oralExamIdVerificationStateRejectionReasonCode';
export * from './oralExamIdVerificationStateReviewedAt';
export * from './oralExamIdVerificationStateReviewedBy';
export * from './oralExamIntegrityBudget';
export * from './oralExamLoungeHintResponse';
export * from './oralExamLoungeResponse';
export * from './oralExamLoungeResponseOrientationVideoUrl';
export * from './oralExamLoungeResponseWaitingBedUrl';
export * from './oralExamMediaIntegrity';
export * from './oralExamMediaSource';
export * from './oralExamMediaSourceCurrent';
export * from './oralExamMediaSourceTotal';
export * from './oralExamMode';
export * from './oralExamOperationalFault';
export * from './oralExamPauseReason';
export * from './oralExamPauseRequest';
export * from './oralExamPoolReplaceRequest';
export * from './oralExamPracticeAvailabilityResponse';
export * from './oralExamPracticeAvailabilityResponseBookingId';
export * from './oralExamPracticeAvailabilityResponseCourseId';
export * from './oralExamPracticeAvailabilityResponseModuleId';
export * from './oralExamPracticeAvailabilityResponseReason';
export * from './oralExamPracticeAvailabilityResponseSessionId';
export * from './oralExamPracticeAvailabilityResponseSlotId';
export * from './oralExamPracticeAvailabilityResponseTaskId';
export * from './oralExamPracticeEnsureRequest';
export * from './oralExamPracticeEnsureResponse';
export * from './oralExamPracticeEnsureResponseBookingId';
export * from './oralExamPracticeEnsureResponseSlotId';
export * from './oralExamPresenceLocation';
export * from './oralExamQuestion';
export * from './oralExamQuestionBloom';
export * from './oralExamQuestionConcept';
export * from './oralExamQuestionEstTimeSec';
export * from './oralExamQuestionFillKind';
export * from './oralExamQuestionFills';
export * from './oralExamQuestionQuestionId';
export * from './oralExamQuestionScopedRequest';
export * from './oralExamQuestionScopedRequestQuestionId';
export * from './oralExamReadiness';
export * from './oralExamRecordConsentRequest';
export * from './oralExamRejectIdVerificationRequest';
export * from './oralExamRejectIdVerificationRequestNote';
export * from './oralExamReportMediaRequest';
export * from './oralExamRunStateResponse';
export * from './oralExamRunStateResponseBookingCancellationReason';
export * from './oralExamRunStateResponseBrieferId';
export * from './oralExamRunStateResponseConductAcknowledgedAt';
export * from './oralExamRunStateResponseConductPhase';
export * from './oralExamRunStateResponseConductPolicyVersion';
export * from './oralExamRunStateResponseConsentRecord';
export * from './oralExamRunStateResponseCurrentQuestion';
export * from './oralExamRunStateResponseCurrentQuestionIndex';
export * from './oralExamRunStateResponseEndReason';
export * from './oralExamRunStateResponseEndedAt';
export * from './oralExamRunStateResponseEtag';
export * from './oralExamRunStateResponseExaminerReadyAt';
export * from './oralExamRunStateResponseFirstSeenAt';
export * from './oralExamRunStateResponseIdPhotoBlobPath';
export * from './oralExamRunStateResponseIdSelfiePhotoBlobPath';
export * from './oralExamRunStateResponseIdVerification';
export * from './oralExamRunStateResponseIntegrityBudget';
export * from './oralExamRunStateResponseLecturerAbsentAt';
export * from './oralExamRunStateResponseOperationalFault';
export * from './oralExamRunStateResponseOrientationCompletedAt';
export * from './oralExamRunStateResponsePauseReason';
export * from './oralExamRunStateResponsePreflightLobbyReadyAt';
export * from './oralExamRunStateResponseQuestionDeadline';
export * from './oralExamRunStateResponseQuestionMarkerStartedAt';
export * from './oralExamRunStateResponseRecordingStatus';
export * from './oralExamRunStateResponseSessionId';
export * from './oralExamRunStateResponseSlotOwnerId';
export * from './oralExamRunStateResponseStageGate';
export * from './oralExamRunStateResponseStartAuthority';
export * from './oralExamRunStateResponseStartedAt';
export * from './oralExamRunStateResponseStudentDoneAt';
export * from './oralExamRunStateResponseStudentReadyAt';
export * from './oralExamRunStateResponseSupervisorBroadcast';
export * from './oralExamRunStateResponseSupervisorName';
export * from './oralExamRunStateResponseSupervisorPhotoBlobPath';
export * from './oralExamRunStateResponseSupervisorView';
export * from './oralExamRunStateResponseVoidCause';
export * from './oralExamSession';
export * from './oralExamSessionFilledQuestions';
export * from './oralExamSessionPhase';
export * from './oralExamSessionQuestion';
export * from './oralExamSessionQuestionEndedAt';
export * from './oralExamSessionQuestionStartedAt';
export * from './oralExamSessionQuestionTranscriptHtml';
export * from './oralExamSessionQuestionWording';
export * from './oralExamStageGateResponse';
export * from './oralExamStartCohortRequest';
export * from './oralExamStartTimeSlotRequest';
export * from './oralExamStudentSupervisorFaceResponse';
export * from './oralExamStudentSupervisorFaceResponseDisplayName';
export * from './oralExamStudentSupervisorFaceResponsePhotoBlobPath';
export * from './oralExamStudentSupervisorViewResponse';
export * from './oralExamStudentSupervisorViewResponseVisitor';
export * from './oralExamSubEvaluationInput';
export * from './oralExamSubEvaluationInputDimGrades';
export * from './oralExamSubEvaluationOutput';
export * from './oralExamSubEvaluationOutputDimGrades';
export * from './oralExamSubEvaluationOutputQuestionFeedback';
export * from './oralExamSubEvaluationRatingInput';
export * from './oralExamSubEvaluationRatingInputDimGrades';
export * from './oralExamSubEvaluationRatingInputQuestionFeedback';
export * from './oralExamSubEvaluationRatingOutput';
export * from './oralExamSubEvaluationRatingOutputDimGrades';
export * from './oralExamSubEvaluationRatingOutputQuestionFeedback';
export * from './oralExamSubmissionEvaluation';
export * from './oralExamSubmissionEvaluationOverallFeedback';
export * from './oralExamSubmissionEvaluationPromptVersion';
export * from './oralExamSubmitIdentityPhotosRequest';
export * from './oralExamSupervisionAbsenceResponse';
export * from './oralExamSupervisorBroadcast';
export * from './oralExamSupervisorEntryResponse';
export * from './oralExamSupervisorEntryResponseDisplayName';
export * from './oralExamSupervisorEntryResponsePhotoBlobPath';
export * from './oralExamSupervisorEntryResponseVisit';
export * from './oralExamSupervisorStatus';
export * from './oralExamSupervisorVisitResponse';
export * from './oralExamSupervisorVisitResponseRung';
export * from './oralExamTaskEvaluationInput';
export * from './oralExamTaskEvaluationInputOverallFeedback';
export * from './oralExamTaskEvaluationInputPromptVersion';
export * from './oralExamTaskEvaluationInputSubEvaluations';
export * from './oralExamTaskEvaluationOutput';
export * from './oralExamTaskEvaluationOutputOverallFeedback';
export * from './oralExamTaskEvaluationOutputPromptVersion';
export * from './oralExamTaskEvaluationOutputSubEvaluations';
export * from './oralExamTimeSlotStateResponse';
export * from './oralExamTimeSlotStateResponseBrieferId';
export * from './oralExamTimeSlotStateResponseEtag';
export * from './oralExamTimeSlotStateResponseInExamEnteredAt';
export * from './oralExamTimeSlotStateResponseSlotOwnerId';
export * from './oralExamTimeSlotStateResponseStageGate';
export * from './oralExamTokenResponse';
export * from './oralExamTranscribeJobParams';
export * from './oralExamTransitionPhaseRequest';
export * from './oralExamUploadSupervisorPhotoRequest';
export * from './overrideModuleGradeHeaders';
export * from './paceAnalysis';
export * from './paceAnalysisBenchmarkProgressAtCurrentDay';
export * from './paginationInfo';
export * from './passwordChangeRequest';
export * from './passwordResetConfirm';
export * from './passwordResetRequest';
export * from './pauseOralExamHeaders';
export * from './pendingEvaluation';
export * from './pendingEvaluationDueDate';
export * from './pendingEvaluationGrade';
export * from './pendingEvaluationGradedAt';
export * from './pendingEvaluationGrading';
export * from './pendingEvaluationSubmittedAt';
export * from './peopleProfile';
export * from './peopleProfileFirstName';
export * from './peopleProfilePatchRequest';
export * from './peopleProfilePatchRequestClearProfilePhoto';
export * from './peopleProfilePatchRequestOpenToConnectGss';
export * from './peopleProfilePatchRequestPhone';
export * from './peopleProfilePatchRequestShareEmail';
export * from './peopleProfilePatchRequestSharePhone';
export * from './peopleProfilePatchRequestShareWhatsapp';
export * from './peopleProfilePatchRequestShowPhotoToConnections';
export * from './peopleProfilePatchRequestWhatsapp';
export * from './peopleProfilePhone';
export * from './peopleProfilePhotoUploadRequest';
export * from './peopleProfilePhotoUrlResponse';
export * from './peopleProfilePhotoUrlResponseUrl';
export * from './peopleProfileProfilePhotoBlobPath';
export * from './peopleProfileShareEmail';
export * from './peopleProfileWhatsapp';
export * from './performanceLevelConfig';
export * from './performanceLevelDescription';
export * from './performanceLevelDescriptionInput';
export * from './performanceLevelDescriptionOutput';
export * from './persistMcqAnswerParams';
export * from './planningStatus';
export * from './pltBusinessStudentComment';
export * from './pltBusinessStudentCommentInput';
export * from './pltBusinessStudentCommentOutput';
export * from './pltStudentComment';
export * from './pltStudentCommentInput';
export * from './pltStudentCommentOutput';
export * from './point';
export * from './pointValue';
export * from './pointX';
export * from './pointsFigure';
export * from './pointsFigureAxis';
export * from './pointsFigureUnit';
export * from './processingMode';
export * from './processingOptions';
export * from './processingOptionsProcessorModes';
export * from './processingReconcileParams';
export * from './processingReconcileParamsSlaMinutes';
export * from './progressCurveAnalysis';
export * from './progressCurvePoint';
export * from './questionAnswer';
export * from './questionAnswerSelectedOptionIds';
export * from './questionAnswerTextResponse';
export * from './questionOption';
export * from './questionOptionValue';
export * from './questionType';
export * from './reassignSubmissionParams';
export * from './recordOralExamConsentHeaders';
export * from './recurrenceRequest';
export * from './recurrenceRequestCount';
export * from './recurrenceRequestFreq';
export * from './recurrenceRequestUntil';
export * from './redrawOralExamQuestionsHeaders';
export * from './referringResource';
export * from './refreshRequest';
export * from './rejectOralExamIdVerificationHeaders';
export * from './releaseLine';
export * from './repeatOralExamPreviousQuestionBody';
export * from './repeatOralExamPreviousQuestionHeaders';
export * from './reportIdNameReference';
export * from './reportIdNameReferenceExternalStudentId';
export * from './reportIdNameReferenceFirstname';
export * from './reportIdNameReferenceLastname';
export * from './reportIdTitleReference';
export * from './reportIdTitleReferenceTitle';
export * from './reportOralExamMediaDisabledBody';
export * from './reportOralExamMediaDisabledHeaders';
export * from './reportOralExamMediaEnabledBody';
export * from './reportOralExamMediaEnabledHeaders';
export * from './requestModuleVersionApprovalBody';
export * from './requestOralExamHelpHeaders';
export * from './rescheduleSlotRequest';
export * from './resetMcqAttemptParams';
export * from './resetOralExamHeaders';
export * from './resetOralExamTimerBody';
export * from './resetOralExamTimerHeaders';
export * from './resource';
export * from './resourceDescription';
export * from './resourceLinkCreateRequest';
export * from './resourceLinkCreateRequestCitation';
export * from './resourceLinkCreateRequestDescription';
export * from './resourceLinkCreateRequestTitle';
export * from './resourceMetadata';
export * from './resourceMetadataContent';
export * from './resourceMetadataCreate';
export * from './resourceMetadataCreateContent';
export * from './resourcePosition';
export * from './resourceProcessJobParams';
export * from './resourceProcessingReconcileParams';
export * from './resourceProgress';
export * from './resourceThumbnailUrls';
export * from './resourceThumbnailUrlsAnyOf';
export * from './resourceUpdateRequest';
export * from './resourceUpdateRequestCitation';
export * from './resourceUpdateRequestDescription';
export * from './resourceUpdateRequestOralExamRelevant';
export * from './resourceUpdateRequestPosition';
export * from './resourceUpdateRequestTitle';
export * from './resourceUpdateRequestUrl';
export * from './resourceUrl';
export * from './responsibilities';
export * from './responsibilitiesEvaluation';
export * from './responsibilitiesEvents';
export * from './rubricDimensionInput';
export * from './rubricDimensionInputParams';
export * from './rubricDimensionOutput';
export * from './rubricDimensionOutputParams';
export * from './rubricGenerationInput';
export * from './rubricPromptData';
export * from './rubricPromptDataExpectedRubric';
export * from './rubricPromptDataQualityScore';
export * from './rubricScoringCriterion';
export * from './runAutogradeJobRequest';
export * from './runBulkJobRequest';
export * from './runBulkJobRequestLabel';
export * from './runEvaluationMonitoringJobRequest';
export * from './runEventCoverageCheckJobRequest';
export * from './runEventParticipantReminderJobRequest';
export * from './runEventPlanningCheckJobRequest';
export * from './runJobInEngineBody';
export * from './runJobInEngineJobsRunJobTypePostBody';
export * from './runJobInEngineJobsRunJobTypePostParams';
export * from './runJobInEngineParams';
export * from './runJobRequest';
export * from './runJobRequestParams';
export * from './runLecturerBriefingJobRequest';
export * from './runLecturerSessionReminderJobRequest';
export * from './runMeetingNotificationsCleanupJobRequest';
export * from './runMeetingNotificationsEnsureJobRequest';
export * from './runMeetingsEmptySlotsCancelJobRequest';
export * from './runMeetingsEventCompletionFinalizeJobRequest';
export * from './runMeetingsLivekitOralUnwindJobRequest';
export * from './runMeetingsNoShowFinalizeJobRequest';
export * from './runMeetingsTeamsOralUnwindJobRequest';
export * from './runOralExamEgressGuardReconcileJobRequest';
export * from './runOralExamTranscribeJobRequest';
export * from './runProcessingReconcileJobRequest';
export * from './runResourceProcessJobRequest';
export * from './runResourceProcessingReconcileJobRequest';
export * from './runScheduledChangeGenerateJobRequest';
export * from './runScheduledChangesTickJobRequest';
export * from './runTeamsHealthcheckJobRequest';
export * from './runTestJobRequest';
export * from './runTrialUserGarbageCollectionJobRequest';
export * from './runUpdateLifecycleStatesJobRequest';
export * from './runWorkingModeApplyJobRequest';
export * from './scheduledChangeDetail';
export * from './scheduledChangeDetailAppliedVersion';
export * from './scheduledChangeDetailGoLiveAt';
export * from './scheduledChangeDetailWorkingMode';
export * from './scheduledChangeGenerateParams';
export * from './scheduledChangeSummary';
export * from './scheduledChangeSummaryAppliedVersion';
export * from './scheduledChangeSummaryGoLiveAt';
export * from './scheduledChangeSwapRequest';
export * from './scheduledChangeSwapRequestNote';
export * from './scheduledChangeSwapRequestReasonCode';
export * from './scheduledChangeVisibleState';
export * from './scheduledChangeWorkingModeChange';
export * from './scheduledChangeWorkingModeDetail';
export * from './scheduledChangeWorkingModeDetailDraftVersion';
export * from './scheduledChangeWorkingModeDetailPublishAs';
export * from './scheduledChangeWorkingModeDetailReason';
export * from './scheduledChangesTickParams';
export * from './scheduledQuestion';
export * from './schedulingObligation';
export * from './schedulingObligationCoverage';
export * from './schedulingObligationModuleTitle';
export * from './schedulingObligationScope';
export * from './score';
export * from './scoreWeight';
export * from './scoringSubmission';
export * from './scoringSubmissionScores';
export * from './scoringSubmissionScoringSchemaName';
export * from './setBookingAdmissionRequest';
export * from './signalOralExamStudentDoneBody';
export * from './signalOralExamStudentDoneHeaders';
export * from './slotBinding';
export * from './slotBindingModuleId';
export * from './slotBindingRequest';
export * from './slotBindingRequestModuleId';
export * from './slotBindingRequestModuleVersion';
export * from './slotStatus';
export * from './startOralExamCohortHeaders';
export * from './startOralExamHeaders';
export * from './startOralExamSelfServiceSessionHeaders';
export * from './studentCommentOutput';
export * from './studentEngagementRecord';
export * from './studentEngagementRecordLastActivity';
export * from './studentEngagementRecordLevelProgress';
export * from './studentEngagementRecordLevelTaskStates';
export * from './studentEngagementRosterInfo';
export * from './studentEngagementRosterInfoStateCounts';
export * from './studentEvaluationFeedback';
export * from './studentEvaluationFeedbackCategory';
export * from './studentEvaluationFeedbackReason';
export * from './studentEvaluationFeedbackRequest';
export * from './studentEvaluationFeedbackRequestCategory';
export * from './studentEvaluationFeedbackRequestReason';
export * from './studentEvaluationFeedbackRequestRunId';
export * from './studentLevelStats';
export * from './studentProgressRecord';
export * from './studentProgressRecordModuleStartDate';
export * from './studentProgressRecordModuleSubmissionDate';
export * from './studentProgressRecordPaceAnalysis';
export * from './studentProgressRecordPredictedFinish';
export * from './studentProgressReport';
export * from './studentProgressReportLevelStats';
export * from './studentProgressReportPagination';
export * from './studentProgressReportProgressCurveAnalysis';
export * from './studentStateUpdateRequest';
export * from './studentWorkflowState';
export * from './subEvaluationResult';
export * from './subEvaluationResultDimGrades';
export * from './submission';
export * from './submissionAttachments';
export * from './submissionCreateRequest';
export * from './submissionCreateRequestLastKnownEtag';
export * from './submissionCreateRequestReferences';
export * from './submissionCreateRequestState';
export * from './submissionCreatedAt';
export * from './submissionEtag';
export * from './submissionEtagReconciledFromStaleClient';
export * from './submissionEvaluation';
export * from './submissionEvaluationAnyOf';
export * from './submissionEvaluationFormativeFeedback';
export * from './submissionEvaluationResult';
export * from './submissionEvaluationResultAnalysis';
export * from './submissionEvaluationResultApplication';
export * from './submissionEvaluationResultDescription';
export * from './submissionEvaluationResultFormal';
export * from './submissionEvaluationResultInput';
export * from './submissionEvaluationResultInputAnalysis';
export * from './submissionEvaluationResultInputApplication';
export * from './submissionEvaluationResultInputDescription';
export * from './submissionEvaluationResultInputFormal';
export * from './submissionEvaluationResultInputReflection';
export * from './submissionEvaluationResultOutput';
export * from './submissionEvaluationResultReflection';
export * from './submissionEvaluationStudentFeedback';
export * from './submissionFeedback';
export * from './submissionFeedbackAnyOf';
export * from './submissionFeedbackFeedback';
export * from './submissionFeedbackFeedbackAnyOf';
export * from './submissionFeedbackLegacyFeedback';
export * from './submissionFeedbackProperty';
export * from './submissionFeedbackPropertyAnyOf';
export * from './submissionId';
export * from './submissionLegacyFeedback';
export * from './submissionMcqResult';
export * from './submissionModifiedAt';
export * from './submissionModuleId';
export * from './submissionOralExamEvaluation';
export * from './submissionOralExamSession';
export * from './submissionRecord';
export * from './submissionRecordAttemptNumber';
export * from './submissionRecordCorrectionDate';
export * from './submissionRecordCorrectionDuedate';
export * from './submissionRecordCorrector';
export * from './submissionRecordEtag';
export * from './submissionRecordExamAttemptsAllowed';
export * from './submissionRecordExamAttemptsUsed';
export * from './submissionRecordExamNextAction';
export * from './submissionRecordGrading';
export * from './submissionRecordState';
export * from './submissionRecordStudent';
export * from './submissionRecordSubmissionDate';
export * from './submissionReferences';
export * from './submissionReport';
export * from './submissionReportPagination';
export * from './submissionState';
export * from './submissionTaskId';
export * from './submissionText';
export * from './submissionUserId';
export * from './submitMcqAttemptCoursesCourseIdModulesModuleIdTasksTaskIdMcqSubmitPostParams';
export * from './submitMcqAttemptParams';
export * from './submitModuleFeedback';
export * from './submitModuleFeedbackEvaluatorId';
export * from './submitModuleFeedbackGrade';
export * from './submitModuleFeedbackScoring';
export * from './submitOralExamBookingForEvaluationHeaders';
export * from './submitOralExamIdentityPhotosHeaders';
export * from './suggestNewTaskParams';
export * from './supervisorPhotoUrlResponse';
export * from './supervisorPhotoUrlResponseUrl';
export * from './systemMessage';
export * from './systemMessageButtonLabel';
export * from './systemMessageButtonLink';
export * from './systemMessageLevel';
export * from './task';
export * from './taskAnalysis';
export * from './taskAnalysisDimensions';
export * from './taskAnalysisProperty';
export * from './taskBinding';
export * from './taskBindingApi';
export * from './taskBindingApiTaskVersion';
export * from './taskBindingRequest';
export * from './taskBindingRequestTaskVersion';
export * from './taskBindingTaskVersion';
export * from './taskCompletionMinLevelsEffective';
export * from './taskCompletionMinLevelsEffectiveAnyOf';
export * from './taskCompletionMinLevelsOverride';
export * from './taskCompletionMinLevelsOverrideAnyOf';
export * from './taskCompletionPolicyEffective';
export * from './taskCompletionPolicyOverride';
export * from './taskCreateRequest';
export * from './taskCreateRequestAnalysis';
export * from './taskCreateRequestCompletionMinLevelsOverride';
export * from './taskCreateRequestCompletionMinLevelsOverrideAnyOf';
export * from './taskCreateRequestCompletionPolicyOverride';
export * from './taskCreateRequestDescription';
export * from './taskCreateRequestEvaluation';
export * from './taskCreateRequestEventConfig';
export * from './taskCreateRequestRubric';
export * from './taskCreateRequestSortIndex';
export * from './taskCreateRequestTitle';
export * from './taskDraft';
export * from './taskDraftDescription';
export * from './taskEvaluation';
export * from './taskEvaluationConfig';
export * from './taskEvaluationConfigAttachmentPolicy';
export * from './taskEvaluationConfigCompletionMinLevelsEffective';
export * from './taskEvaluationConfigCompletionMinLevelsEffectiveAnyOf';
export * from './taskEvaluationConfigCompletionMinLevelsOverride';
export * from './taskEvaluationConfigCompletionMinLevelsOverrideAnyOf';
export * from './taskEvaluationConfigCompletionPolicyEffective';
export * from './taskEvaluationConfigCompletionPolicyOverride';
export * from './taskEvaluationConfigFeedback';
export * from './taskEvaluationConfigFormalCriteria';
export * from './taskEvaluationConfigFormalCriteriaSource';
export * from './taskEvaluationConfigGradingCategoryId';
export * from './taskEvaluationConfigGradingRelevant';
export * from './taskEvaluationConfigInput';
export * from './taskEvaluationConfigInputCompletionMinLevelsEffective';
export * from './taskEvaluationConfigInputCompletionMinLevelsEffectiveAnyOf';
export * from './taskEvaluationConfigInputCompletionMinLevelsOverride';
export * from './taskEvaluationConfigInputCompletionMinLevelsOverrideAnyOf';
export * from './taskEvaluationConfigInputCompletionPolicyEffective';
export * from './taskEvaluationConfigInputCompletionPolicyOverride';
export * from './taskEvaluationConfigInputFeedback';
export * from './taskEvaluationConfigInputFormalCriteria';
export * from './taskEvaluationConfigInputFormalCriteriaSource';
export * from './taskEvaluationConfigInputGradingRelevant';
export * from './taskEvaluationConfigOutput';
export * from './taskEvaluationConfigOutputCompletionMinLevelsEffective';
export * from './taskEvaluationConfigOutputCompletionMinLevelsEffectiveAnyOf';
export * from './taskEvaluationConfigOutputCompletionMinLevelsOverride';
export * from './taskEvaluationConfigOutputCompletionMinLevelsOverrideAnyOf';
export * from './taskEvaluationConfigOutputCompletionPolicyEffective';
export * from './taskEvaluationConfigOutputCompletionPolicyOverride';
export * from './taskEvaluationConfigOutputFeedback';
export * from './taskEvaluationConfigOutputFormalCriteria';
export * from './taskEvaluationConfigOutputFormalCriteriaSource';
export * from './taskEvaluationConfigOutputGradingRelevant';
export * from './taskEvaluationRequest';
export * from './taskEvaluationRequestEvaluation';
export * from './taskEvaluationRequestEvaluationAnyOf';
export * from './taskEvaluationRequestFeedback';
export * from './taskEventConfig';
export * from './taskFeedback';
export * from './taskFeedbackHighlighting';
export * from './taskFeedbackHighlightingAnyOf';
export * from './taskFeedbackSettings';
export * from './taskFeedbackSettingsInput';
export * from './taskFeedbackSettingsOutput';
export * from './taskFeedbackStyleEnum';
export * from './taskFeedbackText';
export * from './taskFormalCriteria';
export * from './taskFormalCriteriaCitations';
export * from './taskFormalCriteriaConfig';
export * from './taskFormalCriteriaInput';
export * from './taskFormalCriteriaInputCitations';
export * from './taskFormalCriteriaOutput';
export * from './taskGradeInput';
export * from './taskGradeInputDimGrades';
export * from './taskGradeInputSubEvaluations';
export * from './taskGradingSystem';
export * from './taskGradingSystemProperty';
export * from './taskMcqConfig';
export * from './taskObjectives';
export * from './taskObjectivesDimensions';
export * from './taskOralExamConfig';
export * from './taskRemintedFromTaskId';
export * from './taskResources';
export * from './taskRubric';
export * from './taskRubricAnalysis';
export * from './taskRubricApplication';
export * from './taskRubricDescription';
export * from './taskRubricFormal';
export * from './taskRubricInput';
export * from './taskRubricInputAnalysis';
export * from './taskRubricInputApplication';
export * from './taskRubricInputDescription';
export * from './taskRubricInputFormal';
export * from './taskRubricInputReflection';
export * from './taskRubricOutput';
export * from './taskRubricProperty';
export * from './taskRubricReflection';
export * from './taskRubricV1';
export * from './taskRubricV2Input';
export * from './taskRubricV2Output';
export * from './taskSubmission';
export * from './taskSubmissionEvaluation';
export * from './taskSubmissionEvaluationInput';
export * from './taskSubmissionEvaluationOutput';
export * from './taskSubmissionReference';
export * from './taskSubmissionVersionDetail';
export * from './taskSubmissionVersionDetailContentHash';
export * from './taskSubmissionVersionSummary';
export * from './taskSubmissionVersionSummaryContentHash';
export * from './taskTypeEnum';
export * from './taskUpdateRequest';
export * from './taskUpdateRequestAnalysis';
export * from './taskUpdateRequestCompletionMinLevelsOverride';
export * from './taskUpdateRequestCompletionMinLevelsOverrideAnyOf';
export * from './taskUpdateRequestCompletionPolicyOverride';
export * from './taskUpdateRequestDescription';
export * from './taskUpdateRequestEvaluation';
export * from './taskUpdateRequestEventConfig';
export * from './taskUpdateRequestRecursiveUpdateCourses';
export * from './taskUpdateRequestRubric';
export * from './taskUpdateRequestSortIndex';
export * from './taskUpdateRequestTitle';
export * from './taskUpdateRequestType';
export * from './teamsHealthcheckParams';
export * from './tenantContactDb';
export * from './tenantImageAssetUrls';
export * from './tenantNames';
export * from './tenantPublicGradingSettings';
export * from './tenantPublicGradingSettingsEvalDimensions';
export * from './tenantPublicGradingSettingsGradeProjector';
export * from './tenantPublicGradingSettingsGradeProjectorAnyOf';
export * from './tenantPublicGradingSettingsTaskGradeProjectors';
export * from './tenantPublicGradingSettingsTaskGradeProjectorsAnyOf';
export * from './tenantPublicProcessSettings';
export * from './tenantPublicProcessSettingsExamAttemptsPerModule';
export * from './tenantPublicSettings';
export * from './tenantPublicSettingsEventKinds';
export * from './tenantPublicTheme';
export * from './testJobParams';
export * from './thumbnailResolution';
export * from './thumbsDownCheck';
export * from './thumbsDownCheckCheckedAt';
export * from './thumbsDownCheckDraft';
export * from './thumbsDownCheckNextStep';
export * from './thumbsDownCheckObservation';
export * from './thumbsDownList';
export * from './thumbsDownRow';
export * from './tokenResponse';
export * from './trainingDataExport';
export * from './transitionOralExamSessionPhaseHeaders';
export * from './trialUserGarbageCollectionParams';
export * from './updateEvaluationParams';
export * from './updateLifecycleStatesJobParams';
export * from './updateSlotBindingsRequest';
export * from './updateTaskParams';
export * from './updateUserNotificationPreferencesRequest';
export * from './user';
export * from './userActivity';
export * from './userActivityCourseId';
export * from './userActivityData';
export * from './userActivityDataAnyOf';
export * from './userActivityImpersonatedBy';
export * from './userActivityInput';
export * from './userActivityInputCourseId';
export * from './userActivityInputData';
export * from './userActivityInputDataAnyOf';
export * from './userActivityInputModuleId';
export * from './userActivityInputTaskId';
export * from './userActivityInputUserId';
export * from './userActivityModuleId';
export * from './userActivityOutput';
export * from './userActivityTaskId';
export * from './userActivityType';
export * from './userActivityUserId';
export * from './userAuthRequest';
export * from './userAvatar';
export * from './userCohort';
export * from './userContext';
export * from './userContextInput';
export * from './userContextInputActivity';
export * from './userContextInputCurrentModule';
export * from './userContextInputCurrentModuleId';
export * from './userContextInputCurrentTaskIds';
export * from './userContextInputCurrentTaskIdsAnyOf';
export * from './userContextOutput';
export * from './userContextOutputActivity';
export * from './userContextOutputCurrentModule';
export * from './userContextOutputCurrentModuleId';
export * from './userContextOutputCurrentTaskIds';
export * from './userContextOutputCurrentTaskIdsAnyOf';
export * from './userCreate';
export * from './userCreateActive';
export * from './userCreateAvatar';
export * from './userCreateCohort';
export * from './userCreateContext';
export * from './userCreateCourse';
export * from './userCreateCourseRef';
export * from './userCreateCourseRefExternalProductId';
export * from './userCreateCourseRefExtraModuleIds';
export * from './userCreateCourseRefId';
export * from './userCreateExternalStudentId';
export * from './userCreateFeatures';
export * from './userCreateImpersonatedBy';
export * from './userCreatePassword';
export * from './userCreateProfilePhotoBlobPath';
export * from './userCreateRole';
export * from './userCreateState';
export * from './userCreateTitle';
export * from './userCreateTrial';
export * from './userCreateUsername';
export * from './userExternalStudentId';
export * from './userFeatures';
export * from './userFeaturesFlags';
export * from './userImpersonatedBy';
export * from './userLifecycleState';
export * from './userNotificationPreferences';
export * from './userPassword';
export * from './userProfilePhotoBlobPath';
export * from './userResourceProgress';
export * from './userResourceProgressCompletedTimestamp';
export * from './userResourceProgressProgress';
export * from './userResourceProgressUpdate';
export * from './userResourceProgressUpdateProgress';
export * from './userRole';
export * from './userShort';
export * from './userShortCohortId';
export * from './userShortCohortTitle';
export * from './userShortState';
export * from './userState';
export * from './userTitle';
export * from './userTrial';
export * from './userTrialCtaLabel';
export * from './userTrialCtaLink';
export * from './userTrialDurationDays';
export * from './userTrialInput';
export * from './userTrialInputCtaLabel';
export * from './userTrialInputCtaLink';
export * from './userTrialInputDurationDays';
export * from './userTrialInputMessage';
export * from './userTrialInputStartdate';
export * from './userTrialMessage';
export * from './userTrialOutput';
export * from './userTrialOutputCtaLabel';
export * from './userTrialOutputCtaLink';
export * from './userTrialOutputDurationDays';
export * from './userTrialOutputMessage';
export * from './userTrialOutputStartdate';
export * from './userTrialProperty';
export * from './userTrialStartdate';
export * from './userTrialUpdateRequest';
export * from './userTrialUpdateRequestCtaLabel';
export * from './userTrialUpdateRequestCtaLink';
export * from './userTrialUpdateRequestDurationDays';
export * from './userTrialUpdateRequestMessage';
export * from './userTrialUpdateRequestStartdate';
export * from './userUpdate';
export * from './userUpdateActive';
export * from './userUpdateCohort';
export * from './userUpdateEmail';
export * from './userUpdateExternalStudentId';
export * from './userUpdateFeatures';
export * from './userUpdateFeaturesAnyOf';
export * from './userUpdateFirstname';
export * from './userUpdateLastname';
export * from './userUpdateNotificationPrefs';
export * from './userUpdatePassword';
export * from './userUpdateRole';
export * from './userUpdateState';
export * from './userUpdateTitle';
export * from './userUpdateTrial';
export * from './validationError';
export * from './validationErrorLocItem';
export * from './versionHistoryEntry';
export * from './versionHistoryEntryApprovedAt';
export * from './versionHistoryEntryApprovedBy';
export * from './versionHistoryEntrySourceVersion';
export * from './versionHistoryEntryTaskMapping';
export * from './videoMeetingProvider';
export * from './videoProgress';
export * from './videoProgressInput';
export * from './videoProgressOutput';
export * from './workState';
export * from './workingModeActivity';
export * from './workingModeActivityCurrent';
export * from './workingModeActivityDesired';
export * from './workingModeActivityPhase';
export * from './workingModeActivityWritePath';
export * from './workingModeApplyJobParams';
export * from './workingModeApplyLeafSpec';
export * from './workingModeApplyLeafSpecRuleId';
export * from './workingModeApplyRequest';
export * from './workingModeApplyRequestExpectedEtag';
export * from './workingModeApplyRequestTarget';
export * from './workingModeApplyResponse';
export * from './workingModeApplyResponseJobId';
export * from './workingModeApplyResponseWorkingMode';
export * from './workingModeBlockedItem';
export * from './workingModeBlockedItemReasonCode';
export * from './workingModeDiff';
export * from './workingModeDiffCurrentMode';
export * from './workingModeDiffTarget';
export * from './workingModeEntityRef';
